(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("suga", [], factory);
	else if(typeof exports === 'object')
		exports["suga"] = factory();
	else
		root["suga"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 20);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(30);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Device = function () {
    function Device() {
        _classCallCheck(this, Device);
    }

    _createClass(Device, null, [{
        key: 'isInIframe',

        /**
         * @return {boolean} Are we in a iFrame
         */
        value: function isInIframe() {
            return self !== top;
        }

        /**
         * @return {boolean|string} Which IE browser are we
         */

    }, {
        key: 'whichIE',
        value: function whichIE() {
            var myNav = navigator.userAgent.toLowerCase();

            if (myNav.indexOf('msie') !== -1) {
                return parseInt(myNav.split('msie')[1], 10);
            }

            return false;
        }

        /**
         * @return {boolean} is this a webkit browser
         */

    }, {
        key: 'isWebkit',
        value: function isWebkit() {
            return (/WebKit/.test(navigator.userAgent)
            );
        }

        /**
         * @return {boolean} is this iOS
         */

    }, {
        key: 'isIOS',
        value: function isIOS() {
            return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
            );
        }

        /**
         * @return {boolean} is this a touch device
         */

    }, {
        key: 'isTouchscreen',
        value: function isTouchscreen() {
            return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        }

        /**
         * @return {boolean} is the device orientation landscape
         */

    }, {
        key: 'isLandscape',
        value: function isLandscape() {
            var v = Device.getViewport();

            var w = v.w;
            var h = v.h;

            var isLandscape = false;

            if (w > h) {
                isLandscape = true;
            }

            return isLandscape;
        }

        /**
         * @return {number} pixel density 1|2 no higher
         */

    }, {
        key: 'getDpi',
        value: function getDpi() {
            var dpi = Math.floor(window.devicePixelRatio);

            if (dpi > 2) {
                return 2;
            }

            return dpi;
        }

        /**
         * Gets the resource postfix.
         *
         * @param  {number}  dpi  The dpi
         * @return {string}  The resource postfix.
         */

    }, {
        key: 'getResPostfix',
        value: function getResPostfix(dpi) {
            if (!dpi) {
                dpi = Device.getDpi();
            }

            if (dpi === 1) {
                return '';
            }
            var postfix = '@' + dpi + 'x';

            return postfix;
        }

        /**
         * @return {object} the viewport vp.w (width) & vp.h (height)
         */

    }, {
        key: 'getViewport',
        value: function getViewport() {
            var vp = {
                w: Math.floor(document.documentElement.clientWidth, window.innerWidth || 0),
                h: Math.floor(document.documentElement.clientHeight, window.innerHeight || 0)
            };

            return vp;
        }

        /**
         * @param {number} throttleMs - How many ms to throttle
         * @param {function} callback - Event handler
         */

    }, {
        key: 'resize',
        value: function resize(throttleMs, callback) {
            window.addEventListener('resize', function () {
                var vp = Device.getViewport();

                callback(vp);
            });
        }

        /**
         * @param {function} callback - Event handler
         * @return {object} reference to the listener
         */

    }, {
        key: 'pageVisibility',
        value: function pageVisibility(callback) {
            var hidden = void 0;
            var visibilityChange = void 0;

            var handleVisibilityChange = function handleVisibilityChange() {
                if (document[hidden]) {
                    callback(false);

                    return;
                }

                callback(true);
            };

            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                hidden = 'hidden';
                visibilityChange = 'visibilitychange';
            } else if (typeof document.mozHidden !== 'undefined') {
                hidden = 'mozHidden';
                visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                hidden = 'msHidden';
                visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                hidden = 'webkitHidden';
                visibilityChange = 'webkitvisibilitychange';
            }

            // Handle page visibility change
            return document.addEventListener(visibilityChange, handleVisibilityChange, false);
        }

        /**
         * Toggle Fulscreen
         *
         * @param  {DOMElement}   element  The element
         * @return {Boolean}  is fullscreen
         */

    }, {
        key: 'toggleFullscreen',
        value: function toggleFullscreen(element) {
            if (Device.fullscreenElement()) {
                return Device.exitFullscreen();
            }

            return Device.enterFullscreen(element);
        }

        /**
         * Enter Dullscreen
         *
         * @param  {DOMElement}  element  The element
         * @return {Boolean}     WHether we successfully made it into fulscreen
         */

    }, {
        key: 'enterFullscreen',
        value: function enterFullscreen(element) {
            var isFullscreen = false;

            if (element.requestFullscreen) {
                isFullscreen = true;
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                isFullscreen = true;
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                isFullscreen = true;
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                isFullscreen = true;
                element.msRequestFullscreen();
            }

            return isFullscreen;
        }

        /**
         * Leave Fullscreen
         *
         * @return {Boolean}  nolonger in Fullscreen
         */

    }, {
        key: 'exitFullscreen',
        value: function exitFullscreen() {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }

            return false;
        }

        /**
         * Are we currently in Fullscreen
         *
         * @return {Boolean}  Are we currently in Fullscreen
         */

    }, {
        key: 'fullscreenElement',
        value: function fullscreenElement() {
            return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
        }

        /**
         * Is fullscreen possible on this device
         *
         * @return {Boolean}  Is fullscreen possible on this device
         */

    }, {
        key: 'fullscreenEnabled',
        value: function fullscreenEnabled() {
            return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
        }

        /**
         * Adds a clock.
         *
         * @param  {DOMElement}  element  The element
         */

    }, {
        key: 'addClock',
        value: function addClock(element) {
            var clock = document.createElement('div');

            clock.id = 'clock';
            clock.innerHTML = Device.timeNow();

            clock.style.position = 'absolute';
            clock.style.top = '10px';
            clock.style.right = '10px';
            clock.style.zIndex = 99999;
            clock.style.color = '#FFFFFF';
            clock.style.backgroundColor = '#000000';
            clock.style.padding = '5px';
            clock.style.borderRadius = '2px';

            element.appendChild(clock);

            Device.updateClock();
        }

        /**
         * Removes the clock.
         */

    }, {
        key: 'removeClock',
        value: function removeClock() {
            window.setTimeout(Device.prototype.clockTimer);

            var clock = document.getElementById('clock');

            if (!clock) return;
            clock.parentNode.removeChild(clock);
        }

        /**
         * Update the time
         */

    }, {
        key: 'updateClock',
        value: function updateClock() {
            Device.prototype.clockTimer = window.setTimeout(function () {
                var clock = document.getElementById('clock');

                if (!clock) return;
                clock.innerHTML = Device.timeNow();
                Device.updateClock();
            }, 60 * 1000);
        }

        /**
         * Get time right now as 13:10
         *
         * @return {string}  The time
         */

    }, {
        key: 'timeNow',
        value: function timeNow() {
            console.log('TimeNow');
            var d = new Date();
            var h = (d.getHours() < 10 ? '0' : '') + d.getHours();
            var m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
            return h + ':' + m;
        }

        /**
         * Listen for fullscreen changes
         */

    }, {
        key: 'listenForFullscreenChanges',
        value: function listenForFullscreenChanges() {
            if (document.addEventListener) {
                document.addEventListener('webkitfullscreenchange', handler, false);
                document.addEventListener('mozfullscreenchange', handler, false);
                document.addEventListener('fullscreenchange', handler, false);
                document.addEventListener('MSFullscreenChange', handler, false);
            }

            function handler(val) {
                if (Device.fullscreenElement()) {
                    Device.addClock(Device.fullscreenElement());
                } else {
                    Device.removeClock();
                }
            }
        }
    }]);

    return Device;
}();

exports.default = Device;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Network = function () {
    function Network() {
        _classCallCheck(this, Network);
    }

    _createClass(Network, null, [{
        key: 'getJSON',

        /**
         * @param {string} url - Url of json file
         * @param {string} version - To version the urls
         * @param {Function} callback - Completion handler
         */
        value: function getJSON(url, version, callback) {
            url = url + '?v=' + version;

            var request = new XMLHttpRequest();

            // request.timeout = 120000;

            request.open('GET', url, true);

            request.onload = function () {
                return Network.handler(request, callback);
            };

            request.onerror = function (err) {
                return callback(err, null, request.status);
            };

            request.ontimeout = function () {
                return callback('timeout', null, request.status);
            };

            request.send();
        }

        /**
         * Handler function
         *
         * @param  {XMLHttpRequest}    request   The request
         * @param  {Function}  callback  The callback
         */

    }, {
        key: 'handler',
        value: function handler(request, callback) {
            var data = void 0;

            try {
                data = JSON.parse(request.responseText);
            } catch (err) {
                callback(err, null, request.status);

                return;
            }

            callback(null, data, request.status);
        }
    }]);

    return Network;
}();

exports.default = Network;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Progress = function () {
    function Progress() {
        _classCallCheck(this, Progress);
    }

    _createClass(Progress, null, [{
        key: 'init',


        /**
         * Instanitate and selec dom element
         * @param  {string} selector - css selector for getting element
         * @return {SUGA.Progress} for chaining
         */
        value: function init(selector) {
            this.prototype.percent = 0;
            this.prototype.queue = [];
            this.prototype.hasStarted = false;
            this.prototype.isProcessingQueue = false;
            this.prototype.doneDelay = 3000;
            this.prototype.incDelay = 20;

            this.prototype.selector = selector;
            this.prototype.container = document.getElementById(selector);

            this.prototype.bg = document.createElement('div');
            this.prototype.bg.id = 'progress-bg';
            this.prototype.container.appendChild(this.prototype.bg);

            this.prototype.bar = document.createElement('div');
            this.prototype.bar.id = 'progress-bar';
            this.prototype.bg.appendChild(this.prototype.bar);

            this.prototype.label = document.createElement('p');
            this.prototype.label.id = 'progress-percent';
            this.prototype.label.innerHTML = this.prototype.percent + '%';
            this.prototype.container.appendChild(this.prototype.label);

            return this;
        }

        /**
         * Starts progressing
         * @return {SUGA.Progress} for chaining
         */

    }, {
        key: 'start',
        value: function start() {
            this.prototype.bar.style.display = 'block';
            this.prototype.hasStarted = true;

            return this;
        }

        /**
        * Make progress bar end
        * @return {SUGA.Progress} for chaining
        */

    }, {
        key: 'done',
        value: function done() {
            clearTimeout(this.prototype.queueTimer);

            this.prototype.queue = [];
            this.prototype.hasStarted = false;
            this.prototype.isProcessingQueue = false;
            this.prototype.percent = 0;
            this.prototype.bar.style.display = 'none';
            this.prototype.bar.style.width = this.percent + '%';
            this.prototype.label.innerHTML = this.percent + '%';

            return this;
        }

        /**
        * Set percentage
        * @param {number} percentage - Progress percentage
        * @return {SUGA.Progress} for chaining
        */

    }, {
        key: 'set',
        value: function set(percentage) {
            if (!this.prototype.hasStarted) {
                return this;
            }

            this.prototype.queue.push(percentage);

            if (!this.prototype.isProcessingQueue) {
                Progress.processQueue();
            }

            return this;
        }

        /**
         * Process the queue
         * @private
         */

    }, {
        key: 'processQueue',
        value: function processQueue() {
            var _this = this;

            if (this.prototype.queue.length === 0) {
                this.prototype.isProcessingQueue = false;

                return;
            }

            this.prototype.isProcessingQueue = true;

            var amount = this.prototype.queue.shift();

            this.prototype.percent = amount * 100;

            this.prototype.queueTimer = setTimeout(function () {
                if (_this.prototype.percent >= 100) {
                    _this.prototype.percent = 100;
                }

                _this.prototype.bar.style.width = _this.prototype.percent + '%';

                _this.prototype.label.innerHTML = Math.round(_this.prototype.percent) + '%';

                if (_this.prototype.queue.length === 0 && _this.prototype.percent === 100 && _this.prototype.onComplete) {
                    Progress.onComplete();
                }

                Progress.processQueue();
            }, this.prototype.incDelay);
        }

        /**
         * Bump the bar a little
         * @return {SUGA.Progress} for chaining
         */

    }, {
        key: 'increment',
        value: function increment() {
            Progress.set(this.prototype.percent + 0.1 * this.prototype.percent);

            return this;
        }

        /**
         * Destroy this thing
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            Progress.done();

            this.prototype.container.innerHTML = '';

            delete this.prototype.selector;
            delete this.prototype.container;
            delete this.prototype.bg;
            delete this.prototype.bar;
            delete this.prototype.label;
        }
    }]);

    return Progress;
}();

exports.default = Progress;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(34);
var foreach = __webpack_require__(29);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
        /* eslint-disable no-unused-vars, no-restricted-syntax */
        for (var _ in obj) { return false; }
        /* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(0);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(0);
var ES = __webpack_require__(21);
var replace = bind.call(Function.call, String.prototype.replace);

var leftWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;

module.exports = function trim() {
	var S = ES.ToString(ES.CheckObjectCoercible(this));
	return replace(replace(S, leftWhitespace, ''), rightWhitespace, '');
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(8);

var zeroWidthSpace = '\u200b';

module.exports = function getPolyfill() {
	if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace) {
		return String.prototype.trim;
	}
	return implementation;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Currency & number formatting helper
 *
 * @example
 *
 * const currency = new SUGA.Currency(SUGA.Data)
 * const options = currency.setup("de-DE","EUR")
 * const formattedStr = currency.localize(1234.56,true,true)
 * // formattedStr is "1.234,56.00"
 */
var Currency = function () {
    /**
     * @typedef {Object} Options
     * @property {string} format - The format, e.g. `%s%v` is €10
     * @property {string} decimal - The decimal delimiter
     * @property {string} thousand - The thousand delimiter
     * @property {string} symbol - The currency symbol
     */

    /**
     * @param {object} data - currency data
     * @param {object} data.defaults - the most common currency formatting
     * @param {object} data.locales - the locale fallback
     * @param {object} data.currencies - the alternative formatting
     * @returns {SUGA.Currency} for chaining
     */
    function Currency(data) {
        _classCallCheck(this, Currency);

        this.defaults = data.defaults;
        this.locales = data.locales;
        this.currencies = data.currencies;

        return this;
    }

    /**
     * @param {string} locale - localeCode e.g. de-AT
     * @param {string} currency - currencyCode e.g. EUR
     * @returns {Options} the determined options
     */


    _createClass(Currency, [{
        key: 'setup',
        value: function setup(locale, currency) {
            if (!currency || currency === '') {
                throw new Error('No currency code provided');
            }

            if (!locale || locale === '') {
                throw new Error('No locale code provided');
            }

            var cc = currency.toUpperCase();
            var lc = locale;

            // if de-DE or hu-HU make de or hu
            var parts = lc.toLowerCase().split('-');

            if (parts[1] && parts[0] === parts[1]) {
                lc = parts[0];
            }

            var format = void 0;
            var decimal = void 0;
            var thousand = void 0;
            var symbol = void 0;

            // get the symbol
            symbol = this._lookFor(this.currencies.s, cc);

            // attempt to get formatting data for locale
            format = this._lookFor(this.locales.f, lc);
            decimal = this._lookFor(this.locales.d, lc);
            thousand = this._lookFor(this.locales.t, lc);

            // fallback to defaults if we have no data
            if (!format) {
                format = this.defaults.format;
            }
            if (!decimal) {
                decimal = this.defaults.decimal;
            }
            if (!thousand) {
                thousand = this.defaults.thousand;
            }

            // if no symbol use currency code
            if (!symbol) {
                symbol = cc;
                // if no format aswell use a different format
                format = this.defaults.noSymbolFormat;
            }

            thousand = this.nbspToSpace(thousand);
            decimal = this.nbspToSpace(decimal);

            this.options = {
                format: format,
                decimal: decimal,
                thousand: thousand,
                symbol: symbol
            };

            return this.options;
        }

        /**
         * Method that seaches throw data looking for matches
         *
         * @private
         * @param {array} data - data to search through
         * @param {string} query - item we are looking for
         * @return {object} What we found
         */

    }, {
        key: '_lookFor',
        value: function _lookFor(data, query) {
            for (var key in data) {
                var val = data[key];

                for (var i = 0, len = val.length; i < len; i++) {
                    if (val[i] === query) {
                        return key;
                    }
                }
            }

            return null;
        }

        /**
         * Determines if not numeric.
         *
         * @param  {Any}   n  { parameter_description }
         * @return {Boolean}  True if not numeric, False otherwise.
         */

    }, {
        key: 'isNotNumeric',
        value: function isNotNumeric(n) {
            return !(!isNaN(parseFloat(n)) && isFinite(n));
        }

        /**
         * @return {string} The current currency symbol
         */

    }, {
        key: 'getCurrencySymbol',
        value: function getCurrencySymbol() {
            return this.options.symbol;
        }

        /**
         * @param {number} amount - amount to format
         * @param {boolean} [showSymbol] - Should include symbol in formatting
         * @param {boolean} [show00] - should show `00` e.g. €13.00 = €13 but €12.10 = €12.10
         * @return {string} The localized representation of the given amount
         */

    }, {
        key: 'localize',
        value: function localize(amount, showSymbol, show00) {
            if (amount === '') {
                return '';
            }

            amount = parseFloat(amount);

            if (this.isNotNumeric(amount)) {
                console.error('Amount is not valid: ', amount); // eslint-disable-line

                return '';
            }

            if (show00 === undefined) {
                show00 = true;
            }

            amount = this.roundToDecimal(amount);
            var precision = this.getPrecision(amount, show00);
            var value = this.formatNumber(amount, precision, this.options);

            if (showSymbol === undefined) {
                showSymbol = true;
            }

            if (!showSymbol) {
                return value;
            }

            var result = this.options.format;

            result = result.replace('%s', this.options.symbol);
            result = result.replace('%v', value);

            return result;
        }

        /**
         * @param {number} amount - amount to format
         * @param {number} precision - number of decimal places
         * @param {object} options - formatter options
         * @return {string} The localized representation of the given amount with no symbol
         */

    }, {
        key: 'formatNumber',
        value: function formatNumber(amount, precision, options) {
            var usePrecision = precision;
            var negative = amount < 0 ? '-' : '';
            var base = String(parseInt(Math.abs(amount || 0).toFixed(usePrecision), 10));
            var mod = base.length > 3 ? base.length % 3 : 0;

            return negative + (mod ? base.substr(0, mod) + options.thousand : '') + base.substr(mod).replace(/(\d{3})(?=\d)/g, '$1' + options.thousand) + (usePrecision ? options.decimal + Math.abs(amount).toFixed(usePrecision).split('.')[1] : '');
        }

        /**
         * @private
         * @param {number} amount - amount to format
         * @param {boolean} show00 - should show `00` e.g. €13.00 = €13 but €12.10 = €12.10
         * @return {string} The localized representation of the given amount with no symbol
         */

    }, {
        key: 'getPrecision',
        value: function getPrecision(amount, show00) {
            if (show00) {
                return 2;
            }

            if (amount % 1 !== 0) {
                return 2;
            }

            return 0;
        }

        /**
         * @private
         * @param {number} amount - amount to format
         * @return {number} Converts 10.967 = 10.97
         */

    }, {
        key: 'roundToDecimal',
        value: function roundToDecimal(amount) {
            return Math.round(amount * 100) / 100;
        }

        /**
         * @private
         * @param {number} char - character to test
         * @return {number} Returns a whitespace char in place of a nbsp
         */

    }, {
        key: 'nbspToSpace',
        value: function nbspToSpace(char) {
            if (char.charCodeAt(0) === 160) {
                char = String.fromCharCode(32);
            }

            return char;
        }
    }]);

    return Currency;
}();

exports.default = Currency;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var data = {
    defaults: {
        format: '%s%v',
        decimal: '.',
        thousand: ',',
        noSymbolFormat: '%s %v'
    },
    locales: {
        f: {
            '%s %v': ['ar', 'ar-AE', 'ar-BH', 'ar-DJ', 'ar-DZ', 'ar-EG', 'ar-EH', 'ar-ER', 'ar-IL', 'ar-IQ', 'ar-JO', 'ar-KM', 'ar-KW', 'ar-LB', 'ar-LY', 'ar-MA', 'ar-MR', 'ar-OM', 'ar-PS', 'ar-QA', 'ar-SA', 'ar-SD', 'ar-SO', 'ar-SS', 'ar-SY', 'ar-TD', 'ar-TN', 'ar-YE', 'az', 'az-Latn', 'de-AT', 'de-CH', 'de-LI', 'en-AT', 'en-CH', 'en-IN', 'en-NL', 'en-US-POSIX', 'es-AR', 'es-CO', 'es-PY', 'es-UY', 'fr-CH', 'hy', 'it-CH', 'mk', 'mn', 'ms-BN', 'my', 'nb', 'nb-SJ', 'ne', 'ne-IN', 'nl', 'nl-AW', 'nl-BQ', 'nl-CW', 'nl-SR', 'nl-SX', 'pa', 'pa-Guru', 'root', 'ta', 'ta-LK', 'ta-MY', 'ta-SG', 'to', 'ur', 'ur-IN', 'vi'],
            '%v %s': ['be', 'bg', 'bs', 'bs-Latn', 'ca', 'ca-AD', 'ca-ES-VALENCIA', 'ca-FR', 'ca-IT', 'cs', 'da', 'da-GL', 'de', 'de-BE', 'de-LU', 'el', 'el-CY', 'en-150', 'en-BE', 'en-DE', 'en-DK', 'en-FI', 'en-SE', 'en-SI', 'es', 'es-EA', 'es-IC', 'es-PH', 'et', 'eu', 'fi', 'fo', 'fo-DK', 'fr', 'fr-BE', 'fr-BF', 'fr-BI', 'fr-BJ', 'fr-BL', 'fr-CA', 'fr-CD', 'fr-CF', 'fr-CG', 'fr-CI', 'fr-CM', 'fr-DJ', 'fr-DZ', 'fr-GA', 'fr-GF', 'fr-GN', 'fr-GP', 'fr-GQ', 'fr-HT', 'fr-KM', 'fr-LU', 'fr-MA', 'fr-MC', 'fr-MF', 'fr-MG', 'fr-ML', 'fr-MQ', 'fr-MR', 'fr-MU', 'fr-NC', 'fr-NE', 'fr-PF', 'fr-PM', 'fr-RE', 'fr-RW', 'fr-SC', 'fr-SN', 'fr-SY', 'fr-TD', 'fr-TG', 'fr-TN', 'fr-VU', 'fr-WF', 'fr-YT', 'he', 'hr', 'hr-BA', 'hu', 'is', 'it', 'it-SM', 'ka', 'kk', 'ky', 'lt', 'lv', 'nl-BE', 'pl', 'pt-AO', 'pt-CV', 'pt-GW', 'pt-MO', 'pt-MZ', 'pt-PT', 'pt-ST', 'pt-TL', 'ro', 'ro-MD', 'ru', 'ru-BY', 'ru-KG', 'ru-KZ', 'ru-MD', 'ru-UA', 'sk', 'sl', 'sq', 'sq-MK', 'sq-XK', 'sr', 'sr-Cyrl', 'sr-Cyrl-BA', 'sr-Cyrl-ME', 'sr-Cyrl-XK', 'sr-Latn', 'sr-Latn-BA', 'sr-Latn-ME', 'sr-Latn-XK', 'sv', 'sv-SE', 'sv-AX', 'sv-FI', 'tr', 'tr-CY', 'uk', 'uz', 'uz-Latn'],
            '%v%s': ['bn', 'bn-IN']
        },
        d: {
            ',': ['af', 'af-NA', 'ar-DZ', 'ar-LB', 'ar-LY', 'ar-MA', 'ar-MR', 'ar-TN', 'az', 'az-Latn', 'be', 'bg', 'bs', 'bs-Latn', 'ca', 'ca-AD', 'ca-ES-VALENCIA', 'ca-FR', 'ca-IT', 'cs', 'da', 'da-GL', 'de', 'de-AT', 'de-BE', 'de-LU', 'el', 'el-CY', 'en-150', 'en-AT', 'en-BE', 'en-CH', 'en-DE', 'en-DK', 'en-FI', 'en-NL', 'en-SE', 'en-SI', 'en-ZA', 'es', 'es-AR', 'es-BO', 'es-CL', 'es-CO', 'es-CR', 'es-EA', 'es-EC', 'es-GQ', 'es-IC', 'es-PH', 'es-PY', 'es-UY', 'es-VE', 'et', 'eu', 'fi', 'fo', 'fo-DK', 'fr', 'fr-BE', 'fr-BF', 'fr-BI', 'fr-BJ', 'fr-BL', 'fr-CA', 'fr-CD', 'fr-CF', 'fr-CG', 'fr-CI', 'fr-CM', 'fr-DJ', 'fr-DZ', 'fr-GA', 'fr-GF', 'fr-GN', 'fr-GP', 'fr-GQ', 'fr-HT', 'fr-KM', 'fr-LU', 'fr-MA', 'fr-MC', 'fr-MF', 'fr-MG', 'fr-ML', 'fr-MQ', 'fr-MR', 'fr-MU', 'fr-NC', 'fr-NE', 'fr-PF', 'fr-PM', 'fr-RE', 'fr-RW', 'fr-SC', 'fr-SN', 'fr-SY', 'fr-TD', 'fr-TG', 'fr-TN', 'fr-VU', 'fr-WF', 'fr-YT', 'gl', 'hr', 'hr-BA', 'hu', 'hy', 'id', 'is', 'it', 'it-SM', 'ka', 'kk', 'km', 'ky', 'lo', 'lt', 'lv', 'mk', 'ms-BN', 'nb', 'nb-SJ', 'nl', 'nl-AW', 'nl-BE', 'nl-BQ', 'nl-CW', 'nl-SR', 'nl-SX', 'pl', 'pt', 'pt-AO', 'pt-CV', 'pt-GW', 'pt-MO', 'pt-MZ', 'pt-PT', 'pt-ST', 'pt-TL', 'ro', 'ro-MD', 'ru', 'ru-BY', 'ru-KG', 'ru-KZ', 'ru-MD', 'ru-UA', 'sk', 'sl', 'sq', 'sq-MK', 'sq-XK', 'sr', 'sr-Cyrl', 'sr-Cyrl-BA', 'sr-Cyrl-ME', 'sr-Cyrl-XK', 'sr-Latn', 'sr-Latn-BA', 'sr-Latn-ME', 'sr-Latn-XK', 'sv', 'sv-SE', 'sv-AX', 'sv-FI', 'sw-CD', 'tr', 'tr-CY', 'uk', 'uz', 'uz-Latn', 'vi']
        },
        t: {
            ' ': ['af', 'af-NA', 'be', 'bg', 'cs', 'de-AT', 'en-FI', 'en-SE', 'en-ZA', 'es-CR', 'et', 'fi', 'fr', 'fr-BF', 'fr-BI', 'fr-BJ', 'fr-BL', 'fr-CA', 'fr-CD', 'fr-CF', 'fr-CG', 'fr-CH', 'fr-CI', 'fr-CM', 'fr-DJ', 'fr-DZ', 'fr-GA', 'fr-GF', 'fr-GN', 'fr-GP', 'fr-GQ', 'fr-HT', 'fr-KM', 'fr-MC', 'fr-MF', 'fr-MG', 'fr-ML', 'fr-MQ', 'fr-MR', 'fr-MU', 'fr-NC', 'fr-NE', 'fr-PF', 'fr-PM', 'fr-RE', 'fr-RW', 'fr-SC', 'fr-SN', 'fr-SY', 'fr-TD', 'fr-TG', 'fr-TN', 'fr-VU', 'fr-WF', 'fr-YT', 'hu', 'ka', 'kk', 'ky', 'lt', 'lv', 'nb', 'nb-SJ', 'pl', 'pt-AO', 'pt-CV', 'pt-GW', 'pt-MO', 'pt-MZ', 'pt-PT', 'pt-ST', 'pt-TL', 'ru', 'ru-BY', 'ru-KG', 'ru-KZ', 'ru-MD', 'ru-UA', 'sk', 'sq', 'sq-MK', 'sq-XK', 'sv', 'sv-SE', 'sv-AX', 'sv-FI', 'uk', 'uz', 'uz-Latn'],
            '.': ['ar-DZ', 'ar-LB', 'ar-LY', 'ar-MA', 'ar-MR', 'ar-TN', 'az', 'az-Latn', 'bs', 'bs-Latn', 'ca', 'ca-AD', 'ca-ES-VALENCIA', 'ca-FR', 'ca-IT', 'da', 'da-GL', 'de', 'de-BE', 'de-LU', 'el', 'el-CY', 'en-150', 'en-AT', 'en-BE', 'en-CH', 'en-DE', 'en-DK', 'en-NL', 'en-SI', 'es', 'es-AR', 'es-BO', 'es-CL', 'es-CO', 'es-EA', 'es-EC', 'es-GQ', 'es-IC', 'es-PH', 'es-PY', 'es-UY', 'es-VE', 'eu', 'fo', 'fo-DK', 'fr-BE', 'fr-LU', 'fr-MA', 'gl', 'hr', 'hr-BA', 'hy', 'id', 'is', 'it', 'it-SM', 'km', 'lo', 'mk', 'ms-BN', 'nl', 'nl-AW', 'nl-BE', 'nl-BQ', 'nl-CW', 'nl-SR', 'nl-SX', 'pt', 'ro', 'ro-MD', 'sl', 'sr', 'sr-Cyrl', 'sr-Cyrl-BA', 'sr-Cyrl-ME', 'sr-Cyrl-XK', 'sr-Latn', 'sr-Latn-BA', 'sr-Latn-ME', 'sr-Latn-XK', 'sw-CD', 'tr', 'tr-CY', 'vi'],
            '\'': ['de-CH', 'de-LI', 'it-CH']
        }
    },
    currencies: {
        s: {
            '€': ['EUR'],
            '£': ['GBP'],
            kr: ['DKK', 'SEK', 'NOK'],
            $: ['AUD', 'CAD', 'NZD', 'USD', 'HKD', 'SGD'],
            Դ: ['AMD'],
            R$: ['BRL'],
            Kč: ['CZK'],
            '¥': ['JPY', 'CNY'],
            zł: ['PLN'],
            Ft: ['HUF'],
            '₦': ['NGN'],
            '৳': ['BDT'],
            CHF: ['CHF'],
            Rp: ['IDR'],
            '₩': ['KRW'],
            '₨': ['LKR'],
            RM: ['MYR'],
            C$: ['NIO'],
            '₱': ['PHP'],
            '₽': ['RUB'],
            '฿': ['THB'],
            R: ['ZAR'],
            '₺': ['TRY']
        }
    }
};

exports.default = data;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Event = function () {
    function Event() {
        _classCallCheck(this, Event);
    }

    _createClass(Event, null, [{
        key: 'trigger',

        /**
         * @param {string} eventName - Name of event to listen for e.g. 'resize'
         * @param {object} eventData - The data to send along
         * @return {object} Reference to the dispatched event
         */
        value: function trigger(eventName, eventData) {
            if (!eventData) {
                eventData = '';
            }

            var event = new CustomEvent(eventName, { detail: eventData });

            return document.dispatchEvent(event);
        }

        /**
         * @param {string} eventName - Name of event to listen for e.g. 'resize'
         * @param {object} callback - Event handler
         * @param {bool} onlyOnce - Should only fire once
         * @return {object} Reference to the callback function
         */

    }, {
        key: 'on',
        value: function on(eventName, callback, onlyOnce) {
            if (onlyOnce === undefined) {
                onlyOnce = false;
            }

            var _callback = function _callback(e) {
                if (onlyOnce) {
                    Event.off(eventName, _callback);
                }

                callback(e.detail, e);
            };

            document.addEventListener(eventName, _callback, false);

            return _callback;
        }

        /**
          * @param {string} eventName - Name of event to listen for e.g. 'resize'
          * @param {object} callback - Event handler
          * @return {object} Reference to the callback function
          */

    }, {
        key: 'once',
        value: function once(eventName, callback) {
            return Event.on(eventName, callback, true);
        }

        /**
          * @param {string} eventName - Name of event to listen for e.g. 'resize'
          * @param {object} callback - Event handler to remove
          */

    }, {
        key: 'off',
        value: function off(eventName, callback) {
            document.removeEventListener(eventName, callback, false);
        }
    }]);

    return Event;
}();

exports.default = Event;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _webfontloader = __webpack_require__(40);

var _webfontloader2 = _interopRequireDefault(_webfontloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Font = function () {
    function Font() {
        _classCallCheck(this, Font);
    }

    _createClass(Font, null, [{
        key: 'loadFonts',

        /**
         * @param {array} names - List of fonts to load
         * @param {string} url - To css file
         * @param {string} version - To version the urls
         * @param {function} callback - Completion handler
         */
        value: function loadFonts(names, url, version, callback) {
            if (!names || !url || !version) {
                throw new Error('Missing arguements');
            }

            url = url + '?v=' + version;

            _webfontloader2.default.load({
                // google:
                //   families: names
                custom: {
                    families: names,
                    urls: [url]
                },

                active: function active() {
                    var styles = Font.getStylesFromNames(names);

                    if (callback) {
                        callback(styles);
                    }
                },

                inactive: function inactive() {
                    if (callback) {
                        callback(null);
                    }
                }
            });
        }

        /**
         * @private
         * @param {array} names - List of fonts to load
         * @param {function} TextConstructor - A constructor to pre-make all fonts
         *                                   e.g. PIXI.Text
         * @return {array} All the constructed text objects
         */

    }, {
        key: 'getStylesFromNames',
        value: function getStylesFromNames(names) {
            if (!names) {
                throw new Error('Missing names arguement');
            }

            var tmp = [];

            for (var i = names.length - 1; i >= 0; i--) {
                var name = names[i];
                var nameParts = name.split(':');

                if (nameParts[1]) {
                    var weights = nameParts[1].split(',');

                    for (var _i = weights.length - 1; _i >= 0; _i--) {
                        var weight = weights[_i];

                        var font = {
                            fontFamily: nameParts[0],
                            fontWeight: weight[1] + '00'
                        };

                        tmp.push(font);
                    }
                } else {
                    var _font = {
                        fontFamily: nameParts[0],
                        fontWeight: 400
                    };

                    tmp.push(_font);
                }
            }

            return tmp;
        }
    }]);

    return Font;
}();

exports.default = Font;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _progress = __webpack_require__(3);

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class for image manager.
 */
var Loader = function () {
    function Loader() {
        _classCallCheck(this, Loader);
    }

    _createClass(Loader, null, [{
        key: 'loadAsset',

        /**
        * Loads an asset.
        *
        * @param  {String}    url       The url
        * @param  {Function}  callback  The callback
        */
        value: function loadAsset(url, callback) {
            Loader.loadAssets([url], callback);
        }

        /**
        * Loads assets.
        *
        * @param  {String}    urls      The urls
        * @param  {Function}  callback  The callback
        */

    }, {
        key: 'loadAssets',
        value: function loadAssets(urls, callback) {
            if (!this.prototype.loader) {
                this.prototype.loader = new PIXI.loaders.Loader();
            }

            if (!this.prototype.allNamespaces) {
                this.prototype.allNamespaces = [];
            }

            urls = window.UTIL.uniq(urls);

            var tmp = [];

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Array.from(urls)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var url = _step.value;

                    if (!this.prototype.loader.resources[url]) {
                        tmp.push(url);

                        var extension = url.split('.').pop();

                        if (extension === 'json') {
                            this.prototype.allNamespaces.push(url);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (!tmp.length) {
                callback('All assets already loaded', null);

                return;
            }

            this.prototype.loader.defaultQueryString = 'v=' + window.__version;
            this.prototype.loader.add(tmp);

            this.prototype.loader.on('progress', function (progress) {
                _progress2.default.set(progress.progress / 100);
            });

            this.prototype.loader.on('error', function (err) {
                callback(err, null);
            });

            this.prototype.loader.once('complete', function (result) {
                callback(null, result);
            });

            this.prototype.loader.load();
        }

        /**
         * Makes an array of textures from name.
         *
         * @param  {String}  name  The name
         * @return {Array}   Sorted array of textures
         */

    }, {
        key: 'makeTexturesFromName',
        value: function makeTexturesFromName(name) {
            var textures = [];

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Array.from(this.prototype.allNamespaces)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var namespace = _step2.value;

                    var newTextures = Loader.makeTexturesFromNamespace(namespace, name);

                    textures = textures.concat(newTextures);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            window.UTIL.sortArrayByKey(textures, ['__name']);

            return textures;
        }

        /**
         * Makes an array of textures from namespace.
         *
         * @param  {String}  namespace  The namespace
         * @param  {String}  name       The name
         * @return {Array}   Sorted array of textures
         */

    }, {
        key: 'makeTexturesFromNamespace',
        value: function makeTexturesFromNamespace(namespace, name) {
            var textures = this.prototype.loader.resources[namespace].textures;

            var re = new RegExp(name, 'g');

            var tmp = [];

            for (var key in textures) {
                var value = textures[key];

                if (key.match(re)) {
                    value.__name = key;
                    tmp.push(value);
                }
            }

            return tmp;
        }

        /**
         * Gets the sprite sheet image names.
         *
         * @return {Array}  The sprite sheet image names.
         */

    }, {
        key: 'getSpriteSheetImageNames',
        value: function getSpriteSheetImageNames() {
            var tmp = [];

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = Array.from(this.prototype.allNamespaces)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var resourceName = _step3.value;

                    tmp.push(resourceName + '_image');
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return tmp;
        }

        /**
         * Determines if we already have a resource
         *
         * @param  {String}  key  The key
         * @return {Boolean}  True if asset exists else False
         */

    }, {
        key: 'exists',
        value: function exists(key) {
            return !!this.prototype.loader.resources[key];
        }
    }]);

    return Loader;
}();

exports.default = Loader;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _network = __webpack_require__(2);

var _network2 = _interopRequireDefault(_network);

var _nodePolyglot = __webpack_require__(33);

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Locale = function () {
    /**
     * Constructs the object.
     *
     * @param  {string}       defaultLocale  - A locale like 'en'
     * @param  {string}       url            - Url to the dir with the lang files
     * @param  {string}       version        The app version
     * @return {SUGA.Locale}  For chaining
     */
    function Locale(defaultLocale, url, version) {
        _classCallCheck(this, Locale);

        this.url = url;
        this.defaultLocale = defaultLocale;
        this.version = version;

        this.polyglot = new _nodePolyglot2.default({
            warn: function warn(m) {
                return console.warn(m);
            }
        });

        return this;
    }

    /**
     * reset locale files
     */


    _createClass(Locale, [{
        key: 'clearLocales',
        value: function clearLocales() {
            this.polyglot.clear();
            this.hasDefaultLocale = false;
        }

        /**
         * @param {string} localeCode - e.g. en, en-GB
         * @param {function} callback - Completion handler
         */

    }, {
        key: 'setLocale',
        value: function setLocale(localeCode, callback) {
            var chain = this.getLoadingChain(localeCode, this.defaultLocale);

            this.loadLocaleData(chain, callback);
        }

        /**
         * @private
         * @param {string} localeCode - e.g. en, en-GB
         * @param {string} defaultCode - typically 'en'
         * @return {array} locales to load and in order
         */

    }, {
        key: 'getLoadingChain',
        value: function getLoadingChain(localeCode, defaultCode) {
            var chain = [defaultCode];

            if (localeCode === defaultCode || localeCode.length < 2) {
                return chain;
            }

            chain.push(localeCode.substr(0, 2));

            if (localeCode.length <= 4 || localeCode[2] !== '-') {
                return chain;
            }

            chain.push(localeCode);

            return chain;
        }

        /**
         * @private
         * @param {array} chain - e.g. en, en-GB
         * @param {function} callback - Completion handler
         */

    }, {
        key: 'loadLocaleData',
        value: function loadLocaleData(chain, callback) {
            var _this = this;

            var localeCode = chain.shift();

            var path = this.url + localeCode + '.json';

            // get base
            _network2.default.getJSON(path, this.version, function (err, json) {
                if (err) {
                    callback(err);
                }

                if (json && !err) {
                    _this.polyglot.extend(json);
                    _this.polyglot.locale(localeCode);
                }

                // is this an extended code
                if (chain.length > 0) {
                    _this.loadLocaleData(chain, callback);
                } else {
                    callback(null);
                }
            });
        }

        /**
         * Transalate string
         *
         * @param {string} string - phrase to localize
         * @param {object} vars - variables to interpolate
         * @return {string} Localized phrase
         */

    }, {
        key: 'str',
        value: function str(string, vars) {
            return this.polyglot.t(string, vars);
        }
    }]);

    return Locale;
}();

exports.default = Locale;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Reality = function () {
    function Reality() {
        _classCallCheck(this, Reality);
    }

    _createClass(Reality, null, [{
        key: 'init',

        /**
         * Initialzes the thing
         *
         * @param  {number}        interval  - Seconds between notifcations
         * @param  {function}      callback  - Reality check trigger handler
         * @param  {boolean}       debug     The debug
         * @return {SUGA.Reality}  for chaining
         */
        value: function init(interval, callback) {
            var debug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            this.prototype.elapsed = 0;
            this.prototype.started = false;
            this.prototype.startTime = null;
            this.prototype.needsToShowRealityCheck = false;
            this.prototype.allowedToShowRealityCheck = false;
            this.prototype.debug = debug;

            if (interval) {
                Reality.setInterval(interval);
            }

            if (callback) {
                Reality.setHandler(callback);
            }

            this.prototype.isInitialized = true;

            return this;
        }

        /**
         * @param {number} interval - Seconds between notifcations
         */

    }, {
        key: 'setInterval',
        value: function setInterval(interval) {
            if (interval) {
                this.prototype.interval = interval;
            }
        }

        /**
         * @param {number} [callback] - Reality check trigger handler
         */

    }, {
        key: 'setHandler',
        value: function setHandler(callback) {
            if (callback) {
                this.prototype.triggerHandler = callback;
            }
        }

        /**
         * @param {number} [interval] - Seconds between notifcations
         * @param {function} [callback] - Function called when reality check triggered
         */

    }, {
        key: 'start',
        value: function start(interval, callback) {
            if (!this.prototype.isInitialized) {
                throw new Error('Reality check is not initialized');
            }

            if (this.prototype.started) {
                return;
            }

            if (interval) {
                Reality.setInterval(interval);
            }

            if (callback) {
                Reality.setHandler(callback);
            }

            this.prototype.started = true;
            this.prototype.startTime = new Date().getTime();
            this.prototype.lastTime = this.prototype.startTime;

            Reality.loopInterval();
        }

        /**
         * Every n milliseconds check if time has lapsed
         * @private
         */

    }, {
        key: 'loopInterval',
        value: function loopInterval() {
            var _this = this;

            window.setInterval(function () {
                if (_this.prototype.debug) {
                    console.log(_this.prototype.elapsed / 1000, _this.prototype.interval); // eslint-disable-line
                }

                _this.prototype.currentTime = new Date().getTime();
                _this.prototype.elapsed = _this.prototype.currentTime - _this.prototype.lastTime;

                if (_this.prototype.elapsed > _this.prototype.interval * 1000) {
                    _this.prototype.lastTime = new Date().getTime();

                    Reality.tryToShowRealityCheck();
                }
            }, 1000); // Check interval every 1 seconds
        }

        /**
         * A method lets you tell when to & not to trigger a message
         * @param {boolean} allowedToShowRealityCheck - whether one can trigger a message
         * @return {boolean} Flag whether a check was triggered or not
         */

    }, {
        key: 'canShowRealityCheck',
        value: function canShowRealityCheck(allowedToShowRealityCheck) {
            this.prototype.allowedToShowRealityCheck = allowedToShowRealityCheck;

            if (this.prototype.allowedToShowRealityCheck && this.prototype.needsToShowRealityCheck) {
                Reality.triggerRealityCheck();

                return true;
            }

            return false;
        }

        /**
         * Try and trigger a reality check, if we are allowed
         */

    }, {
        key: 'tryToShowRealityCheck',
        value: function tryToShowRealityCheck() {
            if (!this.prototype.allowedToShowRealityCheck) {
                this.prototype.needsToShowRealityCheck = true;

                return;
            }

            Reality.triggerRealityCheck();
        }

        /**
         * @private
         */

    }, {
        key: 'triggerRealityCheck',
        value: function triggerRealityCheck() {
            this.prototype.needsToShowRealityCheck = false;

            var now = new Date().getTime();
            var duration = now - this.prototype.startTime;
            var timeObj = Reality.msToTime(duration);

            this.prototype.triggerHandler(timeObj);
        }

        /**
         * @private
         * @param {number} milli - Milliseconds
         * @return {object} time object with hours and minutes
         */

    }, {
        key: 'msToTime',
        value: function msToTime(milli) {
            var hours = parseInt(milli / (1000 * 60 * 60), 10);
            var mins = Math.round(milli / 1000 / 60) % 60;

            var res = {
                hours: hours,
                minutes: mins
            };

            return res;
        }
    }]);

    return Reality;
}();

exports.default = Reality;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _howlerCoreMin = __webpack_require__(31);

var _device = __webpack_require__(1);

var _device2 = _interopRequireDefault(_device);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Sound = function () {
    function Sound() {
        _classCallCheck(this, Sound);
    }

    _createClass(Sound, null, [{
        key: 'init',


        /**
         * @typedef  {Object}      SoundOpts
         * @property {string}      masterVolume        - the volume of all tracks
         * @property {string}      volumes             - the volume of the individual tracks
         * @property {string}      mute                - Tis playback silent
         * @property {string}      audioSpriteObj      - json sprite sheet object (see Howler docs)
         * @property {string}      mp3                 - url to the audio mp3 files
         * @property {string}      ogg                 - url to the audio ogg files
         * @property {DOMElement}  element             - element to listen for startclick;
         * @property {Boolean}     startOnInteraction  - whether to start immediately or after user interaction
         * @property {Boolean}     autoMute.           - mute audio when the window is not in focus
         */

        /**
         * Constructs the object.
         *
         * @param  {SoundOpts}  options   The options
         * @param  {Function}   callback  The callback
         */
        value: function init(options, callback) {
            Sound.prototype.masterVolume = options.masterVolume;
            Sound.prototype.volumes = options.volumes;
            Sound.prototype.mute = options.mute;
            Sound.prototype.audioSpriteObj = options.audioSpriteObj;
            Sound.prototype.mp3 = options.mp3;
            Sound.prototype.ogg = options.ogg;
            Sound.prototype.ids = {};
            Sound.prototype.element = options.element;
            Sound.prototype.startOnInteraction = options.startOnInteraction;
            Sound.prototype.autoMute = options.autoMute;

            // add some features to Howler
            Sound.extend();

            if (options.startOnInteraction) {
                Sound.startAudioOnInteraction(callback);
            } else {
                Sound.startAudio(callback);
            }

            if (options.autoMute) {
                Sound.startAutoMute();
            }
        }

        /**
         * Create and start the audio
         *
         * @param  {Function}  callback  The callback
         */

    }, {
        key: 'startAudio',
        value: function startAudio(callback) {
            _howlerCoreMin.Howler.mute(Sound.prototype.mute);

            Sound.prototype.sound = new _howlerCoreMin.Howl({
                src: [Sound.prototype.ogg, Sound.prototype.mp3],
                volume: Sound.prototype.masterVolume,
                sprite: Sound.prototype.audioSpriteObj.sprite,

                onloaderror: function onloaderror(id, error) {
                    if (callback) callback(error);
                },

                onload: function onload() {
                    if (callback) callback(null);
                }
            }); // start bg audio
        }

        /**
         * Starts audio on user interaction.
         *
         * @param  {Function}  callback  The callback
         */

    }, {
        key: 'startAudioOnInteraction',
        value: function startAudioOnInteraction(callback) {
            // Handler function to start Audio on first user interaction
            function startAudio() {
                // remove listener after first touch
                Sound.prototype.element.removeEventListener('touchend', startAudio, false);

                // load the audio files
                Sound.startAudio(callback);
            }

            // add a touch listener in order to start the audio from user interaction
            Sound.prototype.element.addEventListener('touchend', startAudio, false);
        }

        /**
         * Starts the event listener which will pause sound s when page is not visible.
         */

    }, {
        key: 'startAutoMute',
        value: function startAutoMute() {
            _device2.default.pageVisibility(function (isVisible) {
                if (isVisible) {
                    Sound.resumeAll();
                } else {
                    Sound.pauseAll();
                }
            });
        }

        /**
         * Sets the mute.
         *
         * @param  {Function}  newValue  The new value
         */

    }, {
        key: 'setMute',
        value: function setMute(newValue) {
            Sound.prototype.mute = newValue;

            _howlerCoreMin.Howler.mute(newValue);
        }

        /**
         * Play a sound by key and volume
         *
         * @param  {string}   key               The key
         * @param  {number}   vol               The volume
         * @param  {boolean}  onlyIfNotPlaying  Only if not already playing
         * @return {string}   id of playing sound
         */

    }, {
        key: 'play',
        value: function play(key, vol, onlyIfNotPlaying) {
            if (!Sound.prototype.sound) {
                return null;
            }

            if (onlyIfNotPlaying && Sound.prototype.sound.isPlayingByName(key)) {
                return null;
            }

            var id = Sound.prototype.sound.play(key);

            if (vol === null || vol === undefined) {
                vol = 1;
            }

            if (Sound.prototype.volumes[key] !== undefined) {
                vol *= Sound.prototype.volumes[key];
            }

            Sound.prototype.sound.volume(vol, id);

            Sound.prototype.ids[key] = id;

            // Pause if trying to play a sound while page
            // isnt visible
            if (document.hidden && Sound.prototype.autoMute) {
                Sound.prototype.sound.pause(id);
            }

            return id;
        }

        /**
         * Pleases an array of sounds in sequence
         *
         * @param  {Array}     sequence  The sequence
         * @param  {Function}  cb        Called on completion
         * @return {Function} the cancel sequence function
         */

    }, {
        key: 'playSequence',
        value: function playSequence(sequence, cb) {
            if (Sound.prototype.sound) {
                return Sound.prototype.sound.playSequence(sequence, cb);
            }

            return null;
        }

        /**
         * Pause all sounds
         */

    }, {
        key: 'pauseAll',
        value: function pauseAll() {
            if (Sound.prototype.sound) {
                Sound.prototype.sound.pause();
            }
        }

        /**
         * Resum all sounds
         */

    }, {
        key: 'resumeAll',
        value: function resumeAll() {
            if (Sound.prototype.sound) {
                Sound.prototype.sound.unpause(Sound.prototype.volumes);
            }
        }

        /**
         * Stop sound by key
         *
         * @param  {string}  key  The key/name of sound
         */

    }, {
        key: 'stop',
        value: function stop(key) {
            if (Sound.prototype.sound) {
                Sound.prototype.sound.killByName(key);
            }
        }

        /**
         * Fade sound
         *
         * @param  {string}  key   The key/name of sound
         * @param  {number}  to    Ending volume
         * @param  {number}  d     Duration
         */

    }, {
        key: 'fade',
        value: function fade(key, to, d) {
            if (d === null) {
                d = 2000;
            }

            var id = Sound.prototype.ids[key];

            if (!Sound.prototype.sound || !id) {
                return;
            }

            var from = Sound.prototype.sound.getSoundById(id)._volume;

            if (Sound.prototype.volumes[key] !== undefined) {
                to *= Sound.prototype.volumes[key];
            }

            Sound.prototype.sound.fade(from, to, d, id);
        }

        /**
         * Extend the functionality of Howler
         */

    }, {
        key: 'extend',
        value: function extend() {
            function unpause(volumes) {
                var self = this;
                var id = void 0;
                var i = 0;

                while (i < self._sounds.length) {
                    if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        var track = self._sounds[i];

                        id = track._id;
                        self.play(id, volumes[track._sprite]);
                    }
                    i++;
                }

                return self;
            }

            /**
             * Kill track by name
             *
             * @param  {String}  name  The name
             * @return {Object}  Self fo chaining
             */
            function killByName(name) {
                var self = this;
                var id = void 0;
                var track = void 0;
                var i = 0;

                while (i < self._sounds.length) {
                    track = self._sounds[i];
                    if (track._sprite && track._sprite === name) {
                        id = self._sounds[i]._id;
                        self.stop(id);
                    }
                    i++;
                }

                return self;
            }

            function isPlayingByName(name) {
                var self = this;
                var track = void 0;
                var i = 0;

                while (i < self._sounds.length) {
                    track = self._sounds[i];
                    if (track._sprite && track._sprite === name && !track._paused && !track._ended) {
                        return true;
                    }
                    i++;
                }

                return false;
            }

            function getSoundById(id) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this._sounds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var sound = _step.value;

                        if (sound._id === id) {
                            return sound;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return null;
            }

            function playSequence(sequence, handler) {
                var _this = this;

                var stop = false;
                var playingId = void 0;

                var stopFn = function stopFn() {
                    stop = true;
                    _this.stop(playingId);
                    if (handler) handler();
                };

                var recursiveSequence = function recursiveSequence(seq) {
                    if (stop) {
                        seq = [];

                        return;
                    }

                    var item = seq.shift();

                    if (item) {
                        var _cb = function _cb(endedId) //eslint-disable-line
                        {
                            if (id === endedId) {
                                this.off('end', _cb);
                                recursiveSequence(seq);
                            }
                        };

                        var id = _this.play(item);

                        playingId = id;

                        _this.on('end', _cb);
                    } else if (handler) handler();
                };

                recursiveSequence(sequence);

                return stopFn;
            }

            _howlerCoreMin.Howl.prototype.unpause = unpause;
            _howlerCoreMin.Howl.prototype.killByName = killByName;
            _howlerCoreMin.Howl.prototype.isPlayingByName = isPlayingByName;
            _howlerCoreMin.Howl.prototype.getSoundById = getSoundById;
            _howlerCoreMin.Howl.prototype.playSequence = playSequence;
        }
    }]);

    return Sound;
}();

exports.default = Sound;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Tracking = function () {
    /**
     * Setup the game code
     *
     * @param  {string}  gameCode  The game code
     * @param  {string}  version   The version
     */
    function Tracking(gameCode, version) {
        _classCallCheck(this, Tracking);

        this.gameCode = gameCode;
        this.version = version;
        this.jsErrors();
    }

    /**
     * Track user events
     *
     * @param  {string}  label     The label
     * @param  {string}  category  The category
     * @param  {string}  action    The action
     * @param  {number}  count     The count
     * @return {object} data sent to GA
     */


    _createClass(Tracking, [{
        key: 'event',
        value: function event(label, category, action, count) {
            if (!category) category = 'button';
            if (!action) action = 'click';
            if (!count) count = 0;

            if (!window.ga) return null;

            var event = {
                hitType: 'event', // Required.
                eventCategory: category, // Required.
                eventAction: action, // Required.
                eventLabel: label,
                eventValue: count
            };

            // GA Event tracking
            window.ga('send', event);

            return event;
        }

        /**
         * Track js exceptions
         *
         * @param  {string}   desc   The description
         * @param  {boolean}  fatal  The fatal
         * @return {object} data sent to GA
         */

    }, {
        key: 'exception',
        value: function exception(desc, fatal) {
            if (!fatal) fatal = false;

            if (!window.ga) return null;

            var exception = {
                exDescription: desc,
                exFatal: fatal,
                appName: this.gameCode,
                appVersion: this.version
            };

            window.ga('send', 'exception', exception);

            return exception;
        }

        /**
         * watch for js errors
         */

    }, {
        key: 'jsErrors',
        value: function jsErrors() {
            var _this = this;

            window.addEventListener('error', function (err) {
                var lineAndColumnInfo = err.colno ? ' line:' + err.lineno + ', column:' + err.colno : ' line:' + err.lineno;
                var location = err.filename + lineAndColumnInfo + ' -> ' + navigator.userAgent;

                _this.event('JavaScript Error', err.message, location);
                _this.exception('JSERROR - ' + err.message);
            });
        }
    }]);

    return Tracking;
}();

exports.default = Tracking;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// Polyfill for creating CustomEvents on IE9/10/11

// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

try {
    var ce = new window.CustomEvent('test');
    ce.preventDefault();
    if (ce.defaultPrevented !== true) {
        // IE has problems with .preventDefault() on custom events
        // http://stackoverflow.com/questions/23349191
        throw new Error('Could not prevent default');
    }
} catch(e) {
  var CustomEvent = function(event, params) {
    var evt, origPrevent;
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };

    evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    origPrevent = evt.preventDefault;
    evt.preventDefault = function () {
      origPrevent.call(this);
      try {
        Object.defineProperty(this, 'defaultPrevented', {
          get: function () {
            return true;
          }
        });
      } catch(e) {
        this.defaultPrevented = true;
      }
    };
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent; // expose definition to window
}


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Data = exports.Network = exports.Tracking = exports.Sound = exports.Reality = exports.Loader = exports.Locale = exports.Progress = exports.Font = exports.Event = exports.Device = exports.Currency = undefined;

__webpack_require__(19);

var _currency = __webpack_require__(10);

var _currency2 = _interopRequireDefault(_currency);

var _device = __webpack_require__(1);

var _device2 = _interopRequireDefault(_device);

var _event = __webpack_require__(12);

var _event2 = _interopRequireDefault(_event);

var _font = __webpack_require__(13);

var _font2 = _interopRequireDefault(_font);

var _progress = __webpack_require__(3);

var _progress2 = _interopRequireDefault(_progress);

var _locale = __webpack_require__(15);

var _locale2 = _interopRequireDefault(_locale);

var _loader = __webpack_require__(14);

var _loader2 = _interopRequireDefault(_loader);

var _reality = __webpack_require__(16);

var _reality2 = _interopRequireDefault(_reality);

var _sound = __webpack_require__(17);

var _sound2 = _interopRequireDefault(_sound);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _network = __webpack_require__(2);

var _network2 = _interopRequireDefault(_network);

var _currency3 = __webpack_require__(11);

var _currency4 = _interopRequireDefault(_currency3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Currency = _currency2.default;
exports.Device = _device2.default;
exports.Event = _event2.default;
exports.Font = _font2.default;
exports.Progress = _progress2.default;
exports.Locale = _locale2.default;
exports.Loader = _loader2.default;
exports.Reality = _reality2.default;
exports.Sound = _sound2.default;
exports.Tracking = _tracking2.default;
exports.Network = _network2.default;
exports.Data = _currency4.default;


global.SUGA = exports; // eslint-disable-line
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(23);
var $isFinite = __webpack_require__(22);

var sign = __webpack_require__(25);
var mod = __webpack_require__(24);

var IsCallable = __webpack_require__(7);
var toPrimitive = __webpack_require__(26);

var has = __webpack_require__(6);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return Number(value);
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// http://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};
		// jscs:disable
		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}
		// jscs:enable
		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(27);

var isCallable = __webpack_require__(7);

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function (O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(32)

module.exports = forEach

var toString = Object.prototype.toString
var hasOwnProperty = Object.prototype.hasOwnProperty

function forEach(list, iterator, context) {
    if (!isFunction(iterator)) {
        throw new TypeError('iterator must be a function')
    }

    if (arguments.length < 3) {
        context = this
    }
    
    if (toString.call(list) === '[object Array]')
        forEachArray(list, iterator, context)
    else if (typeof list === 'string')
        forEachString(list, iterator, context)
    else
        forEachObject(list, iterator, context)
}

function forEachArray(array, iterator, context) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            iterator.call(context, array[i], i, array)
        }
    }
}

function forEachString(string, iterator, context) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        iterator.call(context, string.charAt(i), i, string)
    }
}

function forEachObject(object, iterator, context) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            iterator.call(context, object[k], k, object)
        }
    }
}


/***/ }),
/* 29 */
/***/ (function(module, exports) {


var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach (obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};



/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! howler.js v2.0.4 | (c) 2013-2017, James Simpson of GoldFire Studios | MIT License | howlerjs.com */
!function(){"use strict";var e=function(){this.init()};e.prototype={init:function(){var e=this||n;return e._counter=1e3,e._codecs={},e._howls=[],e._muted=!1,e._volume=1,e._canPlayEvent="canplaythrough",e._navigator="undefined"!=typeof window&&window.navigator?window.navigator:null,e.masterGain=null,e.noAudio=!1,e.usingWebAudio=!0,e.autoSuspend=!0,e.ctx=null,e.mobileAutoEnable=!0,e._setup(),e},volume:function(e){var o=this||n;if(e=parseFloat(e),o.ctx||_(),void 0!==e&&e>=0&&e<=1){if(o._volume=e,o._muted)return o;o.usingWebAudio&&(o.masterGain.gain.value=e);for(var t=0;t<o._howls.length;t++)if(!o._howls[t]._webAudio)for(var r=o._howls[t]._getSoundIds(),a=0;a<r.length;a++){var u=o._howls[t]._soundById(r[a]);u&&u._node&&(u._node.volume=u._volume*e)}return o}return o._volume},mute:function(e){var o=this||n;o.ctx||_(),o._muted=e,o.usingWebAudio&&(o.masterGain.gain.value=e?0:o._volume);for(var t=0;t<o._howls.length;t++)if(!o._howls[t]._webAudio)for(var r=o._howls[t]._getSoundIds(),a=0;a<r.length;a++){var u=o._howls[t]._soundById(r[a]);u&&u._node&&(u._node.muted=!!e||u._muted)}return o},unload:function(){for(var e=this||n,o=e._howls.length-1;o>=0;o--)e._howls[o].unload();return e.usingWebAudio&&e.ctx&&void 0!==e.ctx.close&&(e.ctx.close(),e.ctx=null,_()),e},codecs:function(e){return(this||n)._codecs[e.replace(/^x-/,"")]},_setup:function(){var e=this||n;if(e.state=e.ctx?e.ctx.state||"running":"running",e._autoSuspend(),!e.usingWebAudio)if("undefined"!=typeof Audio)try{var o=new Audio;void 0===o.oncanplaythrough&&(e._canPlayEvent="canplay")}catch(n){e.noAudio=!0}else e.noAudio=!0;try{var o=new Audio;o.muted&&(e.noAudio=!0)}catch(e){}return e.noAudio||e._setupCodecs(),e},_setupCodecs:function(){var e=this||n,o=null;try{o="undefined"!=typeof Audio?new Audio:null}catch(n){return e}if(!o||"function"!=typeof o.canPlayType)return e;var t=o.canPlayType("audio/mpeg;").replace(/^no$/,""),r=e._navigator&&e._navigator.userAgent.match(/OPR\/([0-6].)/g),a=r&&parseInt(r[0].split("/")[1],10)<33;return e._codecs={mp3:!(a||!t&&!o.canPlayType("audio/mp3;").replace(/^no$/,"")),mpeg:!!t,opus:!!o.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/,""),ogg:!!o.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),oga:!!o.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),wav:!!o.canPlayType('audio/wav; codecs="1"').replace(/^no$/,""),aac:!!o.canPlayType("audio/aac;").replace(/^no$/,""),caf:!!o.canPlayType("audio/x-caf;").replace(/^no$/,""),m4a:!!(o.canPlayType("audio/x-m4a;")||o.canPlayType("audio/m4a;")||o.canPlayType("audio/aac;")).replace(/^no$/,""),mp4:!!(o.canPlayType("audio/x-mp4;")||o.canPlayType("audio/mp4;")||o.canPlayType("audio/aac;")).replace(/^no$/,""),weba:!!o.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/,""),webm:!!o.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/,""),dolby:!!o.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/,""),flac:!!(o.canPlayType("audio/x-flac;")||o.canPlayType("audio/flac;")).replace(/^no$/,"")},e},_enableMobileAudio:function(){var e=this||n,o=/iPhone|iPad|iPod|Android|BlackBerry|BB10|Silk|Mobi/i.test(e._navigator&&e._navigator.userAgent),t=!!("ontouchend"in window||e._navigator&&e._navigator.maxTouchPoints>0||e._navigator&&e._navigator.msMaxTouchPoints>0);if(!e._mobileEnabled&&e.ctx&&(o||t)){e._mobileEnabled=!1,e._mobileUnloaded||44100===e.ctx.sampleRate||(e._mobileUnloaded=!0,e.unload()),e._scratchBuffer=e.ctx.createBuffer(1,1,22050);var r=function(){n._autoResume();var o=e.ctx.createBufferSource();o.buffer=e._scratchBuffer,o.connect(e.ctx.destination),void 0===o.start?o.noteOn(0):o.start(0),"function"==typeof e.ctx.resume&&e.ctx.resume(),o.onended=function(){o.disconnect(0),e._mobileEnabled=!0,e.mobileAutoEnable=!1,document.removeEventListener("touchend",r,!0)}};return document.addEventListener("touchend",r,!0),e}},_autoSuspend:function(){var e=this;if(e.autoSuspend&&e.ctx&&void 0!==e.ctx.suspend&&n.usingWebAudio){for(var o=0;o<e._howls.length;o++)if(e._howls[o]._webAudio)for(var t=0;t<e._howls[o]._sounds.length;t++)if(!e._howls[o]._sounds[t]._paused)return e;return e._suspendTimer&&clearTimeout(e._suspendTimer),e._suspendTimer=setTimeout(function(){e.autoSuspend&&(e._suspendTimer=null,e.state="suspending",e.ctx.suspend().then(function(){e.state="suspended",e._resumeAfterSuspend&&(delete e._resumeAfterSuspend,e._autoResume())}))},3e4),e}},_autoResume:function(){var e=this;if(e.ctx&&void 0!==e.ctx.resume&&n.usingWebAudio)return"running"===e.state&&e._suspendTimer?(clearTimeout(e._suspendTimer),e._suspendTimer=null):"suspended"===e.state?(e.ctx.resume().then(function(){e.state="running";for(var n=0;n<e._howls.length;n++)e._howls[n]._emit("resume")}),e._suspendTimer&&(clearTimeout(e._suspendTimer),e._suspendTimer=null)):"suspending"===e.state&&(e._resumeAfterSuspend=!0),e}};var n=new e,o=function(e){var n=this;if(!e.src||0===e.src.length)return void console.error("An array of source files must be passed with any new Howl.");n.init(e)};o.prototype={init:function(e){var o=this;return n.ctx||_(),o._autoplay=e.autoplay||!1,o._format="string"!=typeof e.format?e.format:[e.format],o._html5=e.html5||!1,o._muted=e.mute||!1,o._loop=e.loop||!1,o._pool=e.pool||5,o._preload="boolean"!=typeof e.preload||e.preload,o._rate=e.rate||1,o._sprite=e.sprite||{},o._src="string"!=typeof e.src?e.src:[e.src],o._volume=void 0!==e.volume?e.volume:1,o._duration=0,o._state="unloaded",o._sounds=[],o._endTimers={},o._queue=[],o._onend=e.onend?[{fn:e.onend}]:[],o._onfade=e.onfade?[{fn:e.onfade}]:[],o._onload=e.onload?[{fn:e.onload}]:[],o._onloaderror=e.onloaderror?[{fn:e.onloaderror}]:[],o._onpause=e.onpause?[{fn:e.onpause}]:[],o._onplay=e.onplay?[{fn:e.onplay}]:[],o._onstop=e.onstop?[{fn:e.onstop}]:[],o._onmute=e.onmute?[{fn:e.onmute}]:[],o._onvolume=e.onvolume?[{fn:e.onvolume}]:[],o._onrate=e.onrate?[{fn:e.onrate}]:[],o._onseek=e.onseek?[{fn:e.onseek}]:[],o._onresume=[],o._webAudio=n.usingWebAudio&&!o._html5,void 0!==n.ctx&&n.ctx&&n.mobileAutoEnable&&n._enableMobileAudio(),n._howls.push(o),o._autoplay&&o._queue.push({event:"play",action:function(){o.play()}}),o._preload&&o.load(),o},load:function(){var e=this,o=null;if(n.noAudio)return void e._emit("loaderror",null,"No audio support.");"string"==typeof e._src&&(e._src=[e._src]);for(var r=0;r<e._src.length;r++){var u,i;if(e._format&&e._format[r])u=e._format[r];else{if("string"!=typeof(i=e._src[r])){e._emit("loaderror",null,"Non-string found in selected audio sources - ignoring.");continue}u=/^data:audio\/([^;,]+);/i.exec(i),u||(u=/\.([^.]+)$/.exec(i.split("?",1)[0])),u&&(u=u[1].toLowerCase())}if(u||console.warn('No file extension was found. Consider using the "format" property or specify an extension.'),u&&n.codecs(u)){o=e._src[r];break}}return o?(e._src=o,e._state="loading","https:"===window.location.protocol&&"http:"===o.slice(0,5)&&(e._html5=!0,e._webAudio=!1),new t(e),e._webAudio&&a(e),e):void e._emit("loaderror",null,"No codec support for selected audio sources.")},play:function(e,o){var t=this,r=null;if("number"==typeof e)r=e,e=null;else{if("string"==typeof e&&"loaded"===t._state&&!t._sprite[e])return null;if(void 0===e){e="__default";for(var a=0,u=0;u<t._sounds.length;u++)t._sounds[u]._paused&&!t._sounds[u]._ended&&(a++,r=t._sounds[u]._id);1===a?e=null:r=null}}var i=r?t._soundById(r):t._inactiveSound();if(!i)return null;if(r&&!e&&(e=i._sprite||"__default"),"loaded"!==t._state){i._sprite=e,i._ended=!1;var d=i._id;return t._queue.push({event:"play",action:function(){t.play(d)}}),d}if(r&&!i._paused)return o||setTimeout(function(){t._emit("play",i._id)},0),i._id;t._webAudio&&n._autoResume();var _=Math.max(0,i._seek>0?i._seek:t._sprite[e][0]/1e3),s=Math.max(0,(t._sprite[e][0]+t._sprite[e][1])/1e3-_),l=1e3*s/Math.abs(i._rate);i._paused=!1,i._ended=!1,i._sprite=e,i._seek=_,i._start=t._sprite[e][0]/1e3,i._stop=(t._sprite[e][0]+t._sprite[e][1])/1e3,i._loop=!(!i._loop&&!t._sprite[e][2]);var c=i._node;if(t._webAudio){var f=function(){t._refreshBuffer(i);var e=i._muted||t._muted?0:i._volume;c.gain.setValueAtTime(e,n.ctx.currentTime),i._playStart=n.ctx.currentTime,void 0===c.bufferSource.start?i._loop?c.bufferSource.noteGrainOn(0,_,86400):c.bufferSource.noteGrainOn(0,_,s):i._loop?c.bufferSource.start(0,_,86400):c.bufferSource.start(0,_,s),l!==1/0&&(t._endTimers[i._id]=setTimeout(t._ended.bind(t,i),l)),o||setTimeout(function(){t._emit("play",i._id)},0)},p="running"===n.state;if("loaded"===t._state&&p)f();else{var v=p||"loaded"!==t._state?"load":"resume";t.once(v,f,p?i._id:null),t._clearTimer(i._id)}}else{var m=function(){c.currentTime=_,c.muted=i._muted||t._muted||n._muted||c.muted,c.volume=i._volume*n.volume(),c.playbackRate=i._rate,c.play(),l!==1/0&&(t._endTimers[i._id]=setTimeout(t._ended.bind(t,i),l)),o||t._emit("play",i._id)},h="loaded"===t._state&&(window&&window.ejecta||!c.readyState&&n._navigator.isCocoonJS);if(4===c.readyState||h)m();else{var g=function(){m(),c.removeEventListener(n._canPlayEvent,g,!1)};c.addEventListener(n._canPlayEvent,g,!1),t._clearTimer(i._id)}}return i._id},pause:function(e){var n=this;if("loaded"!==n._state)return n._queue.push({event:"pause",action:function(){n.pause(e)}}),n;for(var o=n._getSoundIds(e),t=0;t<o.length;t++){n._clearTimer(o[t]);var r=n._soundById(o[t]);if(r&&!r._paused&&(r._seek=n.seek(o[t]),r._rateSeek=0,r._paused=!0,n._stopFade(o[t]),r._node))if(n._webAudio){if(!r._node.bufferSource)continue;void 0===r._node.bufferSource.stop?r._node.bufferSource.noteOff(0):r._node.bufferSource.stop(0),n._cleanBuffer(r._node)}else isNaN(r._node.duration)&&r._node.duration!==1/0||r._node.pause();arguments[1]||n._emit("pause",r?r._id:null)}return n},stop:function(e,n){var o=this;if("loaded"!==o._state)return o._queue.push({event:"stop",action:function(){o.stop(e)}}),o;for(var t=o._getSoundIds(e),r=0;r<t.length;r++){o._clearTimer(t[r]);var a=o._soundById(t[r]);a&&(a._seek=a._start||0,a._rateSeek=0,a._paused=!0,a._ended=!0,o._stopFade(t[r]),a._node&&(o._webAudio?a._node.bufferSource&&(void 0===a._node.bufferSource.stop?a._node.bufferSource.noteOff(0):a._node.bufferSource.stop(0),o._cleanBuffer(a._node)):isNaN(a._node.duration)&&a._node.duration!==1/0||(a._node.currentTime=a._start||0,a._node.pause())),n||o._emit("stop",a._id))}return o},mute:function(e,o){var t=this;if("loaded"!==t._state)return t._queue.push({event:"mute",action:function(){t.mute(e,o)}}),t;if(void 0===o){if("boolean"!=typeof e)return t._muted;t._muted=e}for(var r=t._getSoundIds(o),a=0;a<r.length;a++){var u=t._soundById(r[a]);u&&(u._muted=e,t._webAudio&&u._node?u._node.gain.setValueAtTime(e?0:u._volume,n.ctx.currentTime):u._node&&(u._node.muted=!!n._muted||e),t._emit("mute",u._id))}return t},volume:function(){var e,o,t=this,r=arguments;if(0===r.length)return t._volume;if(1===r.length||2===r.length&&void 0===r[1]){t._getSoundIds().indexOf(r[0])>=0?o=parseInt(r[0],10):e=parseFloat(r[0])}else r.length>=2&&(e=parseFloat(r[0]),o=parseInt(r[1],10));var a;if(!(void 0!==e&&e>=0&&e<=1))return a=o?t._soundById(o):t._sounds[0],a?a._volume:0;if("loaded"!==t._state)return t._queue.push({event:"volume",action:function(){t.volume.apply(t,r)}}),t;void 0===o&&(t._volume=e),o=t._getSoundIds(o);for(var u=0;u<o.length;u++)(a=t._soundById(o[u]))&&(a._volume=e,r[2]||t._stopFade(o[u]),t._webAudio&&a._node&&!a._muted?a._node.gain.setValueAtTime(e,n.ctx.currentTime):a._node&&!a._muted&&(a._node.volume=e*n.volume()),t._emit("volume",a._id));return t},fade:function(e,o,t,r){var a=this,u=Math.abs(e-o),i=e>o?"out":"in",d=u/.01,_=d>0?t/d:t;if(_<4&&(d=Math.ceil(d/(4/_)),_=4),"loaded"!==a._state)return a._queue.push({event:"fade",action:function(){a.fade(e,o,t,r)}}),a;a.volume(e,r);for(var s=a._getSoundIds(r),l=0;l<s.length;l++){var c=a._soundById(s[l]);if(c){if(r||a._stopFade(s[l]),a._webAudio&&!c._muted){var f=n.ctx.currentTime,p=f+t/1e3;c._volume=e,c._node.gain.setValueAtTime(e,f),c._node.gain.linearRampToValueAtTime(o,p)}var v=e;c._interval=setInterval(function(n,t){d>0&&(v+="in"===i?.01:-.01),v=Math.max(0,v),v=Math.min(1,v),v=Math.round(100*v)/100,a._webAudio?(void 0===r&&(a._volume=v),t._volume=v):a.volume(v,n,!0),(o<e&&v<=o||o>e&&v>=o)&&(clearInterval(t._interval),t._interval=null,a.volume(o,n),a._emit("fade",n))}.bind(a,s[l],c),_)}}return a},_stopFade:function(e){var o=this,t=o._soundById(e);return t&&t._interval&&(o._webAudio&&t._node.gain.cancelScheduledValues(n.ctx.currentTime),clearInterval(t._interval),t._interval=null,o._emit("fade",e)),o},loop:function(){var e,n,o,t=this,r=arguments;if(0===r.length)return t._loop;if(1===r.length){if("boolean"!=typeof r[0])return!!(o=t._soundById(parseInt(r[0],10)))&&o._loop;e=r[0],t._loop=e}else 2===r.length&&(e=r[0],n=parseInt(r[1],10));for(var a=t._getSoundIds(n),u=0;u<a.length;u++)(o=t._soundById(a[u]))&&(o._loop=e,t._webAudio&&o._node&&o._node.bufferSource&&(o._node.bufferSource.loop=e,e&&(o._node.bufferSource.loopStart=o._start||0,o._node.bufferSource.loopEnd=o._stop)));return t},rate:function(){var e,o,t=this,r=arguments;if(0===r.length)o=t._sounds[0]._id;else if(1===r.length){var a=t._getSoundIds(),u=a.indexOf(r[0]);u>=0?o=parseInt(r[0],10):e=parseFloat(r[0])}else 2===r.length&&(e=parseFloat(r[0]),o=parseInt(r[1],10));var i;if("number"!=typeof e)return i=t._soundById(o),i?i._rate:t._rate;if("loaded"!==t._state)return t._queue.push({event:"rate",action:function(){t.rate.apply(t,r)}}),t;void 0===o&&(t._rate=e),o=t._getSoundIds(o);for(var d=0;d<o.length;d++)if(i=t._soundById(o[d])){i._rateSeek=t.seek(o[d]),i._playStart=t._webAudio?n.ctx.currentTime:i._playStart,i._rate=e,t._webAudio&&i._node&&i._node.bufferSource?i._node.bufferSource.playbackRate.value=e:i._node&&(i._node.playbackRate=e);var _=t.seek(o[d]),s=(t._sprite[i._sprite][0]+t._sprite[i._sprite][1])/1e3-_,l=1e3*s/Math.abs(i._rate);!t._endTimers[o[d]]&&i._paused||(t._clearTimer(o[d]),t._endTimers[o[d]]=setTimeout(t._ended.bind(t,i),l)),t._emit("rate",i._id)}return t},seek:function(){var e,o,t=this,r=arguments;if(0===r.length)o=t._sounds[0]._id;else if(1===r.length){var a=t._getSoundIds(),u=a.indexOf(r[0]);u>=0?o=parseInt(r[0],10):(o=t._sounds[0]._id,e=parseFloat(r[0]))}else 2===r.length&&(e=parseFloat(r[0]),o=parseInt(r[1],10));if(void 0===o)return t;if("loaded"!==t._state)return t._queue.push({event:"seek",action:function(){t.seek.apply(t,r)}}),t;var i=t._soundById(o);if(i){if(!("number"==typeof e&&e>=0)){if(t._webAudio){var d=t.playing(o)?n.ctx.currentTime-i._playStart:0,_=i._rateSeek?i._rateSeek-i._seek:0;return i._seek+(_+d*Math.abs(i._rate))}return i._node.currentTime}var s=t.playing(o);s&&t.pause(o,!0),i._seek=e,i._ended=!1,t._clearTimer(o),s&&t.play(o,!0),!t._webAudio&&i._node&&(i._node.currentTime=e),t._emit("seek",o)}return t},playing:function(e){var n=this;if("number"==typeof e){var o=n._soundById(e);return!!o&&!o._paused}for(var t=0;t<n._sounds.length;t++)if(!n._sounds[t]._paused)return!0;return!1},duration:function(e){var n=this,o=n._duration,t=n._soundById(e);return t&&(o=n._sprite[t._sprite][1]/1e3),o},state:function(){return this._state},unload:function(){for(var e=this,o=e._sounds,t=0;t<o.length;t++){if(o[t]._paused||e.stop(o[t]._id),!e._webAudio){/MSIE |Trident\//.test(n._navigator&&n._navigator.userAgent)||(o[t]._node.src="data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA"),o[t]._node.removeEventListener("error",o[t]._errorFn,!1),o[t]._node.removeEventListener(n._canPlayEvent,o[t]._loadFn,!1)}delete o[t]._node,e._clearTimer(o[t]._id);var a=n._howls.indexOf(e);a>=0&&n._howls.splice(a,1)}var u=!0;for(t=0;t<n._howls.length;t++)if(n._howls[t]._src===e._src){u=!1;break}return r&&u&&delete r[e._src],n.noAudio=!1,e._state="unloaded",e._sounds=[],e=null,null},on:function(e,n,o,t){var r=this,a=r["_on"+e];return"function"==typeof n&&a.push(t?{id:o,fn:n,once:t}:{id:o,fn:n}),r},off:function(e,n,o){var t=this,r=t["_on"+e],a=0;if("number"==typeof n&&(o=n,n=null),n||o)for(a=0;a<r.length;a++){var u=o===r[a].id;if(n===r[a].fn&&u||!n&&u){r.splice(a,1);break}}else if(e)t["_on"+e]=[];else{var i=Object.keys(t);for(a=0;a<i.length;a++)0===i[a].indexOf("_on")&&Array.isArray(t[i[a]])&&(t[i[a]]=[])}return t},once:function(e,n,o){var t=this;return t.on(e,n,o,1),t},_emit:function(e,n,o){for(var t=this,r=t["_on"+e],a=r.length-1;a>=0;a--)r[a].id&&r[a].id!==n&&"load"!==e||(setTimeout(function(e){e.call(this,n,o)}.bind(t,r[a].fn),0),r[a].once&&t.off(e,r[a].fn,r[a].id));return t},_loadQueue:function(){var e=this;if(e._queue.length>0){var n=e._queue[0];e.once(n.event,function(){e._queue.shift(),e._loadQueue()}),n.action()}return e},_ended:function(e){var o=this,t=e._sprite;if(!o._webAudio&&o._node&&!o._node.ended)return setTimeout(o._ended.bind(o,e),100),o;var r=!(!e._loop&&!o._sprite[t][2]);if(o._emit("end",e._id),!o._webAudio&&r&&o.stop(e._id,!0).play(e._id),o._webAudio&&r){o._emit("play",e._id),e._seek=e._start||0,e._rateSeek=0,e._playStart=n.ctx.currentTime;var a=1e3*(e._stop-e._start)/Math.abs(e._rate);o._endTimers[e._id]=setTimeout(o._ended.bind(o,e),a)}return o._webAudio&&!r&&(e._paused=!0,e._ended=!0,e._seek=e._start||0,e._rateSeek=0,o._clearTimer(e._id),o._cleanBuffer(e._node),n._autoSuspend()),o._webAudio||r||o.stop(e._id),o},_clearTimer:function(e){var n=this;return n._endTimers[e]&&(clearTimeout(n._endTimers[e]),delete n._endTimers[e]),n},_soundById:function(e){for(var n=this,o=0;o<n._sounds.length;o++)if(e===n._sounds[o]._id)return n._sounds[o];return null},_inactiveSound:function(){var e=this;e._drain();for(var n=0;n<e._sounds.length;n++)if(e._sounds[n]._ended)return e._sounds[n].reset();return new t(e)},_drain:function(){var e=this,n=e._pool,o=0,t=0;if(!(e._sounds.length<n)){for(t=0;t<e._sounds.length;t++)e._sounds[t]._ended&&o++;for(t=e._sounds.length-1;t>=0;t--){if(o<=n)return;e._sounds[t]._ended&&(e._webAudio&&e._sounds[t]._node&&e._sounds[t]._node.disconnect(0),e._sounds.splice(t,1),o--)}}},_getSoundIds:function(e){var n=this;if(void 0===e){for(var o=[],t=0;t<n._sounds.length;t++)o.push(n._sounds[t]._id);return o}return[e]},_refreshBuffer:function(e){var o=this;return e._node.bufferSource=n.ctx.createBufferSource(),e._node.bufferSource.buffer=r[o._src],e._panner?e._node.bufferSource.connect(e._panner):e._node.bufferSource.connect(e._node),e._node.bufferSource.loop=e._loop,e._loop&&(e._node.bufferSource.loopStart=e._start||0,e._node.bufferSource.loopEnd=e._stop),e._node.bufferSource.playbackRate.value=e._rate,o},_cleanBuffer:function(e){var n=this;if(n._scratchBuffer){e.bufferSource.onended=null,e.bufferSource.disconnect(0);try{e.bufferSource.buffer=n._scratchBuffer}catch(e){}}return e.bufferSource=null,n}};var t=function(e){this._parent=e,this.init()};t.prototype={init:function(){var e=this,o=e._parent;return e._muted=o._muted,e._loop=o._loop,e._volume=o._volume,e._rate=o._rate,e._seek=0,e._paused=!0,e._ended=!0,e._sprite="__default",e._id=++n._counter,o._sounds.push(e),e.create(),e},create:function(){var e=this,o=e._parent,t=n._muted||e._muted||e._parent._muted?0:e._volume;return o._webAudio?(e._node=void 0===n.ctx.createGain?n.ctx.createGainNode():n.ctx.createGain(),e._node.gain.setValueAtTime(t,n.ctx.currentTime),e._node.paused=!0,e._node.connect(n.masterGain)):(e._node=new Audio,e._errorFn=e._errorListener.bind(e),e._node.addEventListener("error",e._errorFn,!1),e._loadFn=e._loadListener.bind(e),e._node.addEventListener(n._canPlayEvent,e._loadFn,!1),e._node.src=o._src,e._node.preload="auto",e._node.volume=t*n.volume(),e._node.load()),e},reset:function(){var e=this,o=e._parent;return e._muted=o._muted,e._loop=o._loop,e._volume=o._volume,e._rate=o._rate,e._seek=0,e._rateSeek=0,e._paused=!0,e._ended=!0,e._sprite="__default",e._id=++n._counter,e},_errorListener:function(){var e=this;e._parent._emit("loaderror",e._id,e._node.error?e._node.error.code:0),e._node.removeEventListener("error",e._errorFn,!1)},_loadListener:function(){var e=this,o=e._parent;o._duration=Math.ceil(10*e._node.duration)/10,0===Object.keys(o._sprite).length&&(o._sprite={__default:[0,1e3*o._duration]}),"loaded"!==o._state&&(o._state="loaded",o._emit("load"),o._loadQueue()),e._node.removeEventListener(n._canPlayEvent,e._loadFn,!1)}};var r={},a=function(e){var n=e._src;if(r[n])return e._duration=r[n].duration,void d(e);if(/^data:[^;]+;base64,/.test(n)){for(var o=atob(n.split(",")[1]),t=new Uint8Array(o.length),a=0;a<o.length;++a)t[a]=o.charCodeAt(a);i(t.buffer,e)}else{var _=new XMLHttpRequest;_.open("GET",n,!0),_.responseType="arraybuffer",_.onload=function(){var n=(_.status+"")[0];if("0"!==n&&"2"!==n&&"3"!==n)return void e._emit("loaderror",null,"Failed loading audio file with status: "+_.status+".");i(_.response,e)},_.onerror=function(){e._webAudio&&(e._html5=!0,e._webAudio=!1,e._sounds=[],delete r[n],e.load())},u(_)}},u=function(e){try{e.send()}catch(n){e.onerror()}},i=function(e,o){n.ctx.decodeAudioData(e,function(e){e&&o._sounds.length>0&&(r[o._src]=e,d(o,e))},function(){o._emit("loaderror",null,"Decoding audio data failed.")})},d=function(e,n){n&&!e._duration&&(e._duration=n.duration),0===Object.keys(e._sprite).length&&(e._sprite={__default:[0,1e3*e._duration]}),"loaded"!==e._state&&(e._state="loaded",e._emit("load"),e._loadQueue())},_=function(){try{"undefined"!=typeof AudioContext?n.ctx=new AudioContext:"undefined"!=typeof webkitAudioContext?n.ctx=new webkitAudioContext:n.usingWebAudio=!1}catch(e){n.usingWebAudio=!1}var e=/iP(hone|od|ad)/.test(n._navigator&&n._navigator.platform),o=n._navigator&&n._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/),t=o?parseInt(o[1],10):null;if(e&&t&&t<9){var r=/safari/.test(n._navigator&&n._navigator.userAgent.toLowerCase());(n._navigator&&n._navigator.standalone&&!r||n._navigator&&!n._navigator.standalone&&!r)&&(n.usingWebAudio=!1)}n.usingWebAudio&&(n.masterGain=void 0===n.ctx.createGain?n.ctx.createGainNode():n.ctx.createGain(),n.masterGain.gain.value=n._muted?0:1,n.masterGain.connect(n.ctx.destination)),n._setup()};"function"=="function"&&__webpack_require__(41)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return{Howler:n,Howl:o}}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)),"undefined"!=typeof exports&&(exports.Howler=n,exports.Howl=o),"undefined"!=typeof window?(window.HowlerGlobal=e,window.Howler=n,window.Howl=o,window.Sound=t):"undefined"!=typeof global&&(global.HowlerGlobal=e,global.Howler=n,global.Howl=o,global.Sound=t)}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//     (c) 2012-2016 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documention:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//



var forEach = __webpack_require__(28);
var warning = __webpack_require__(39);
var has = __webpack_require__(6);
var trim = __webpack_require__(37);

var warn = function warn(message) {
  warning(false, message);
};

var replace = String.prototype.replace;
var split = String.prototype.split;

// #### Pluralization methods
// The string that separates the different phrase possibilities.
var delimeter = '||||';

// Mapping from pluralization group plural logic.
var pluralTypes = {
  arabic: function (n) {
    // http://www.arabeyes.org/Plural_Forms
    if (n < 3) { return n; }
    if (n % 100 >= 3 && n % 100 <= 10) return 3;
    return n % 100 >= 11 ? 4 : 5;
  },
  chinese: function () { return 0; },
  german: function (n) { return n !== 1 ? 1 : 0; },
  french: function (n) { return n > 1 ? 1 : 0; },
  russian: function (n) {
    if (n % 10 === 1 && n % 100 !== 11) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  czech: function (n) {
    if (n === 1) { return 0; }
    return (n >= 2 && n <= 4) ? 1 : 2;
  },
  polish: function (n) {
    if (n === 1) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  icelandic: function (n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; }
};

// Mapping from pluralization group to individual locales.
var pluralTypeToLanguages = {
  arabic: ['ar'],
  chinese: ['fa', 'id', 'ja', 'ko', 'lo', 'ms', 'th', 'tr', 'zh'],
  german: ['da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hu', 'it', 'nl', 'no', 'pt', 'sv'],
  french: ['fr', 'tl', 'pt-br'],
  russian: ['hr', 'ru', 'lt'],
  czech: ['cs', 'sk'],
  polish: ['pl'],
  icelandic: ['is']
};

function langToTypeMap(mapping) {
  var ret = {};
  forEach(mapping, function (langs, type) {
    forEach(langs, function (lang) {
      ret[lang] = type;
    });
  });
  return ret;
}

function pluralTypeName(locale) {
  var langToPluralType = langToTypeMap(pluralTypeToLanguages);
  return langToPluralType[locale]
    || langToPluralType[split.call(locale, /-/, 1)[0]]
    || langToPluralType.en;
}

function pluralTypeIndex(locale, count) {
  return pluralTypes[pluralTypeName(locale)](count);
}

var dollarRegex = /\$/g;
var dollarBillsYall = '$$';
var tokenRegex = /%\{(.*?)\}/g;

// ### transformPhrase(phrase, substitutions, locale)
//
// Takes a phrase string and transforms it by choosing the correct
// plural form and interpolating it.
//
//     transformPhrase('Hello, %{name}!', {name: 'Spike'});
//     // "Hello, Spike!"
//
// The correct plural form is selected if substitutions.smart_count
// is set. You can pass in a number instead of an Object as `substitutions`
// as a shortcut for `smart_count`.
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
//     // "1 new message"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
//     // "2 new messages"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
//     // "5 new messages"
//
// You should pass in a third argument, the locale, to specify the correct plural type.
// It defaults to `'en'` with 2 plural forms.
function transformPhrase(phrase, substitutions, locale) {
  if (typeof phrase !== 'string') {
    throw new TypeError('Polyglot.transformPhrase expects argument #1 to be string');
  }

  if (substitutions == null) {
    return phrase;
  }

  var result = phrase;

  // allow number as a pluralization shortcut
  var options = typeof substitutions === 'number' ? { smart_count: substitutions } : substitutions;

  // Select plural form: based on a phrase text that contains `n`
  // plural forms separated by `delimeter`, a `locale`, and a `substitutions.smart_count`,
  // choose the correct plural form. This is only done if `count` is set.
  if (options.smart_count != null && result) {
    var texts = split.call(result, delimeter);
    result = trim(texts[pluralTypeIndex(locale || 'en', options.smart_count)] || texts[0]);
  }

  // Interpolate: Creates a `RegExp` object for each interpolation placeholder.
  result = replace.call(result, tokenRegex, function (expression, argument) {
    if (!has(options, argument) || options[argument] == null) { return expression; }
    // Ensure replacement value is escaped to prevent special $-prefixed regex replace tokens.
    return replace.call(options[argument], dollarRegex, dollarBillsYall);
  });

  return result;
}

// ### Polyglot class constructor
function Polyglot(options) {
  var opts = options || {};
  this.phrases = {};
  this.extend(opts.phrases || {});
  this.currentLocale = opts.locale || 'en';
  var allowMissing = opts.allowMissing ? transformPhrase : null;
  this.onMissingKey = typeof opts.onMissingKey === 'function' ? opts.onMissingKey : allowMissing;
  this.warn = opts.warn || warn;
}

// ### polyglot.locale([locale])
//
// Get or set locale. Internally, Polyglot only uses locale for pluralization.
Polyglot.prototype.locale = function (newLocale) {
  if (newLocale) this.currentLocale = newLocale;
  return this.currentLocale;
};

// ### polyglot.extend(phrases)
//
// Use `extend` to tell Polyglot how to translate a given key.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The key can be any string.  Feel free to call `extend` multiple times;
// it will override any phrases with the same key, but leave existing phrases
// untouched.
//
// It is also possible to pass nested phrase objects, which get flattened
// into an object with the nested keys concatenated using dot notation.
//
//     polyglot.extend({
//       "nav": {
//         "hello": "Hello",
//         "hello_name": "Hello, %{name}",
//         "sidebar": {
//           "welcome": "Welcome"
//         }
//       }
//     });
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}',
//     //   'nav.sidebar.welcome': 'Welcome'
//     // }
//
// `extend` accepts an optional second argument, `prefix`, which can be used
// to prefix every key in the phrases object with some string, using dot
// notation.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     }, "nav");
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}'
//     // }
//
// This feature is used internally to support nested phrase objects.
Polyglot.prototype.extend = function (morePhrases, prefix) {
  forEach(morePhrases, function (phrase, key) {
    var prefixedKey = prefix ? prefix + '.' + key : key;
    if (typeof phrase === 'object') {
      this.extend(phrase, prefixedKey);
    } else {
      this.phrases[prefixedKey] = phrase;
    }
  }, this);
};

// ### polyglot.unset(phrases)
// Use `unset` to selectively remove keys from a polyglot instance.
//
//     polyglot.unset("some_key");
//     polyglot.unset({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The unset method can take either a string (for the key), or an object hash with
// the keys that you would like to unset.
Polyglot.prototype.unset = function (morePhrases, prefix) {
  if (typeof morePhrases === 'string') {
    delete this.phrases[morePhrases];
  } else {
    forEach(morePhrases, function (phrase, key) {
      var prefixedKey = prefix ? prefix + '.' + key : key;
      if (typeof phrase === 'object') {
        this.unset(phrase, prefixedKey);
      } else {
        delete this.phrases[prefixedKey];
      }
    }, this);
  }
};

// ### polyglot.clear()
//
// Clears all phrases. Useful for special cases, such as freeing
// up memory if you have lots of phrases but no longer need to
// perform any translation. Also used internally by `replace`.
Polyglot.prototype.clear = function () {
  this.phrases = {};
};

// ### polyglot.replace(phrases)
//
// Completely replace the existing phrases with a new set of phrases.
// Normally, just use `extend` to add more phrases, but under certain
// circumstances, you may want to make sure no old phrases are lying around.
Polyglot.prototype.replace = function (newPhrases) {
  this.clear();
  this.extend(newPhrases);
};


// ### polyglot.t(key, options)
//
// The most-used method. Provide a key, and `t` will return the
// phrase.
//
//     polyglot.t("hello");
//     => "Hello"
//
// The phrase value is provided first by a call to `polyglot.extend()` or
// `polyglot.replace()`.
//
// Pass in an object as the second argument to perform interpolation.
//
//     polyglot.t("hello_name", {name: "Spike"});
//     => "Hello, Spike"
//
// If you like, you can provide a default value in case the phrase is missing.
// Use the special option key "_" to specify a default.
//
//     polyglot.t("i_like_to_write_in_language", {
//       _: "I like to write in %{language}.",
//       language: "JavaScript"
//     });
//     => "I like to write in JavaScript."
//
Polyglot.prototype.t = function (key, options) {
  var phrase, result;
  var opts = options == null ? {} : options;
  if (typeof this.phrases[key] === 'string') {
    phrase = this.phrases[key];
  } else if (typeof opts._ === 'string') {
    phrase = opts._;
  } else if (this.onMissingKey) {
    var onMissingKey = this.onMissingKey;
    result = onMissingKey(key, opts, this.currentLocale);
  } else {
    this.warn('Missing translation for key: "' + key + '"');
    result = key;
  }
  if (typeof phrase === 'string') {
    result = transformPhrase(phrase, opts, this.currentLocale);
  }
  return result;
};


// ### polyglot.has(key)
//
// Check if polyglot has a translation for given key
Polyglot.prototype.has = function (key) {
  return has(this.phrases, key);
};

// export transformPhrase
Polyglot.transformPhrase = transformPhrase;

module.exports = Polyglot;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es5-shim
var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__(35);
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = [
	'toString',
	'toLocaleString',
	'valueOf',
	'hasOwnProperty',
	'isPrototypeOf',
	'propertyIsEnumerable',
	'constructor'
];
var equalsConstructorPrototype = function (o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = (function () {
	/* global window */
	if (typeof window === 'undefined') { return false; }
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2));
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) {
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(0);
var define = __webpack_require__(5);

var implementation = __webpack_require__(8);
var getPolyfill = __webpack_require__(9);
var shim = __webpack_require__(38);

var boundTrim = bind.call(Function.call, getPolyfill());

define(boundTrim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundTrim;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(5);
var getPolyfill = __webpack_require__(9);

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, { trim: function () { return String.prototype.trim !== polyfill; } });
	return polyfill;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (process.env.NODE_ENV !== 'production') {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.o=b||a;this.c=this.o.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
function ea(a){return a.o.location.hostname||a.a.location.hostname}function z(a,b,c){function d(){m&&e&&f&&(m(g),m=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,m=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
function A(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function B(){this.a=0;this.c=null}function C(a){a.a++;return function(){a.a--;D(a)}}function E(a,b){a.c=b;D(a)}function D(a){0==a.a&&a.c&&(a.c(),a.c=null)};function F(a){this.a=a||"-"}F.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function G(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return H(a)+" "+(a.f+"00")+" 300px "+I(a.c)}function I(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function J(a){return a.a+a.f}function H(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.o.document.documentElement;this.h=b;this.a=new F("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);K(a,"loading")}function L(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}K(a,"inactive")}function K(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,J(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function M(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function N(a){u(a.c,"body",a.a)}function O(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+I(a.c)+";"+("font-style:"+H(a)+";font-weight:"+(a.f+"00")+";")};function P(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}P.prototype.start=function(){var a=this.c.o.document,b=this,c=q(),d=new Promise(function(d,e){function f(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(f,25)},function(){e()})}f()}),e=null,f=new Promise(function(a,d){e=setTimeout(d,b.f)});Promise.race([f,d]).then(function(){e&&(clearTimeout(e),e=null);b.g(b.a)},function(){b.j(b.a)})};function Q(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.m=this.j=this.h=this.g=null;this.g=new M(this.c,this.s);this.h=new M(this.c,this.s);this.j=new M(this.c,this.s);this.m=new M(this.c,this.s);a=new G(this.a.c+",serif",J(this.a));a=O(a);this.g.a.style.cssText=a;a=new G(this.a.c+",sans-serif",J(this.a));a=O(a);this.h.a.style.cssText=a;a=new G("serif",J(this.a));a=O(a);this.j.a.style.cssText=a;a=new G("sans-serif",J(this.a));a=
O(a);this.m.a.style.cssText=a;N(this.g);N(this.h);N(this.j);N(this.m)}var R={D:"serif",C:"sans-serif"},S=null;function T(){if(null===S){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);S=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return S}Q.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.m.a.offsetWidth;this.A=q();U(this)};
function la(a,b,c){for(var d in R)if(R.hasOwnProperty(d)&&b===a.f[R[d]]&&c===a.f[R[d]])return!0;return!1}function U(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=T()&&la(a,b,c));d?q()-a.A>=a.w?T()&&la(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):ma(a):V(a,a.v)}function ma(a){setTimeout(p(function(){U(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.m.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.m=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,J(a).toString(),"active")],[b.a.c("wf",a.c,J(a).toString(),"loading"),b.a.c("wf",a.c,J(a).toString(),"inactive")]);K(b,"fontactive",a);this.m=!0;na(this)};
W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,J(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,J(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,J(a).toString(),"inactive"));w(b.f,d,e)}K(b,"fontinactive",a);na(this)};function na(a){0==--a.f&&a.j&&(a.m?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),K(a,"active")):L(a.a))};function oa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}oa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;pa(this,new ha(this.c,a),a)};
function qa(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,m=d||null||{};if(0===c.length&&f)L(b.a);else{b.f+=c.length;f&&(b.j=f);var h,l=[];for(h=0;h<c.length;h++){var k=c[h],n=m[k.c],r=b.a,x=k;r.g&&w(r.f,[r.a.c("wf",x.c,J(x).toString(),"loading")]);K(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),xa=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
X=x?42<parseInt(x[1],10):xa?!1:!0}else X=!1;X?r=new P(p(b.g,b),p(b.h,b),b.c,k,b.s,n):r=new Q(p(b.g,b),p(b.h,b),b.c,k,b.s,a,n);l.push(r)}for(h=0;h<l.length;h++)l[h].start()}},0)}function pa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){qa(a,f,b,d,c)})};function ra(a,b){this.c=a;this.a=b}
ra.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var l=0;l<c.length;l++){var k=c[l].fontfamily;void 0!=c[l].fontStyle&&void 0!=c[l].fontWeight?(h=c[l].fontStyle+c[l].fontWeight,e.push(new G(k,h))):e.push(new G(k))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.o;A(this.c,(c.a.api||"https://fast.fonts.net/jsapi")+"/"+d+".js"+(e?"?v="+e:""),function(e){e?a([]):(f["__MonotypeConfiguration__"+
d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+d}else a([])};function sa(a,b){this.c=a;this.a=b}sa.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new B;b=0;for(c=d.length;b<c;b++)z(this.c,d[b],C(g));var m=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),l=0;l<h.length;l+=1)m.push(new G(d[0],h[l]));else m.push(new G(d[0]));E(g,function(){a(m,f)})};function ta(a,b){a?this.c=a:this.c=ua;this.a=[];this.f=[];this.g=b||""}var ua="https://fonts.googleapis.com/css";function va(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
function wa(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function ya(a){this.f=a;this.a=[];this.c={}}
var za={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Aa={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Ba={i:"i",italic:"i",n:"n",normal:"n"},
Ca=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
function Da(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var m=d[1];g=[];if(m)for(var m=m.split(","),h=m.length,l=0;l<h;l++){var k;k=m[l];if(k.match(/^[\w-]+$/)){var n=Ca.exec(k.toLowerCase());if(null==n)k="";else{k=n[2];k=null==k||""==k?"n":Ba[k];n=n[1];if(null==n||""==n)n="4";else var r=Aa[n],n=r?r:isNaN(n)?"4":n.substr(0,1);k=[k,n].join("")}}else k="";k&&g.push(k)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
g,0<d.length&&(d=za[d[0]])&&(a.c[e]=d))}a.c[e]||(d=za[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new G(e,f[d]))}};function Ea(a,b){this.c=a;this.a=b}var Fa={Arimo:!0,Cousine:!0,Tinos:!0};Ea.prototype.load=function(a){var b=new B,c=this.c,d=new ta(this.a.api,this.a.text),e=this.a.families;va(d,e);var f=new ya(e);Da(f);z(c,wa(d),C(b));E(b,function(){a(f.a,f.c,Fa)})};function Ga(a,b){this.c=a;this.a=b}Ga.prototype.load=function(a){var b=this.a.id,c=this.c.o;b?A(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],m=b[f+1],h=0;h<m.length;h++)e.push(new G(g,m[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(l){}a(e)}},2E3):a([])};function Ha(a,b){this.c=a;this.f=b;this.a=[]}Ha.prototype.load=function(a){var b=this.f.id,c=this.c.o,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,m=c.fonts.length;g<m;++g){var h=c.fonts[g];d.a.push(new G(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},A(this.c,(this.f.api||"https://f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new oa(window);Y.a.c.custom=function(a,b){return new sa(b,a)};Y.a.c.fontdeck=function(a,b){return new Ha(b,a)};Y.a.c.monotype=function(a,b){return new ra(b,a)};Y.a.c.typekit=function(a,b){return new Ga(b,a)};Y.a.c.google=function(a,b){return new Ea(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ }),
/* 41 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ })
/******/ ]);
});
//# sourceMappingURL=suga.js.map


//////////////////
// WEBPACK FOOTER
// ../~/suga/lib/suga.js
// module id = 0
// module chunks = d-game